import { Controller, FormProvider, useFieldArray, useForm, useFormContext } from "react-hook-form";
import cargoDetail from "../assets/images/worldwide-shipping.svg";
import party1 from "../assets/images/party.svg";
import dollar from "../assets/images/dollarIcon.svg";
import master from "../assets/images/master.svg";
import carrier from "../assets/images/carrier.svg";
import LabeledTextField from "../mui-components/LabeledTextField";
import deleteicon from "../assets/images/deletei.svg";
import { useEffect, useRef, useState } from "react";
import LabeledSelectField, { LabeledMultiSelectField, LabeledTextSelecField } from "../mui-components/LabeledSelectField";
import { AgmodalStore, configStore, dataListStore, EntityV2Store, filtersState, loginStore } from "../state/CommonState";
import Api from "../state/Api";
import { ServerLists } from "../StaticData";
import { AgMuiUn } from "../mui-components/AgAutoComplete";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { masterjobStore, resetMasterJobStore } from "./masterjobStore";
import { useSnapshot } from "valtio";
import { LabeledRadioButton } from "../v3-componets/AgLabeledRadioButton";
import { SHIPMENT_SCOPE } from "../util/quotationUtil";
import { LinkedBookings } from "./linkedBooking";
import { selectFieldLabelStyle, textFieldLabelStyle } from "./labelStyles";
import BranchApi from "../state/branch-api";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ChargesErp from "../mytasks/ChargesErp";
import ChevronUp from "../assets/images/up1.svg"
import ChevronDown from "../assets/images/down1.svg"
import FileText from "../assets/images/file1.svg"
import Eye from "../assets/images/eye2.svg"
import Download from "../assets/images/download12.svg"
import UploadCloud from "../assets/images/uploadIcon12.svg"
import Trash2 from "../assets/images/delIcon12.svg"
import Switch from "@mui/material/Switch";
import Utils from "../util/Utils";
import { DocumentRenderer, DocumentViewerWrapper } from "../mui-components/DocumentViewerWrapper";
import { dsrstatic_cn, dsrstatic_FCLDockDock, dsrstatic_FCLDockDock_keys } from "../my-actions/dsr_static";
import { myactionsstore } from "../my-actions/store-myactions";
import { TsModal } from "../my-actions/tsmodal";
import { ExceptionModal } from "../my-actions/exceptionModal";

const visibilityDateFields = new Set([
    'vgm_cut_off', 'shipping_instructions_cut_off', 'shipbill_cutoff',
    'container_gate_cut_off', 'gate_opening', 'ams_cutoff', 'isf_cutoff',
    'cargo_gatein_CFS', 'etd_at_pol', 'sob_pol', 'ts1_arrival_estimate',
    'ts1_arrival', 'ts1_departure_estimate', 'ts1_departure',
    'ts2_arrival_estimate', 'ts2_arrival', 'ts2_departure_estimate',
    'ts2_departure', 'ts3_arrival_estimate', 'ts3_arrival',
    'ts3_departure_estimate', 'ts3_departure', 'ts4_arrival_estimate',
    'ts4_arrival', 'ts4_departure_estimate', 'ts4_departure',
    'arrival_notice', 'eta_at_pod', 'pod_arrival', 'etd_pod',
    'gateout_to_fpod', 'eta_fpod', 'gatein_fpod', 'gate_cut_off',
    'last_free_date_at_fpod', 'delivery_order_release',
    'empty_container_arrival_at_por', 'stuffing_confirmation', 'gatein_pol',
    'gateout_to_fpod', 'gatein_fpod', 'gateout_to_fpod', 'gatein_fpod', 'container_pickup_fpod',
    'estimate_delivery_date_to_consignee', 'container_delivery', 'empty_return', 'empty_container_arrival_at_por',
    'container_arrival_at_fpod', 'container_de_vanning', 'container_handover', 'por_to_pol_movement', 'carrier_booking_release'
]);

const visibilityDateTimeFields = new Set([
    "vgm_cut_off", "shipping_instructions_cut_off", "shipbill_cutoff",
    "container_gate_cut_off", 'ams_cutoff', 'isf_cutoff', 'gate_opening', 'gate_cut_off',
    'stuffing_cutoff', 'leo_cutoff'
]);

export function CreateMastersJob(props) {
   useSnapshot(masterjobStore)
    const snapMaster = useSnapshot(masterjobStore)
    const [data,setData] = useState([])
    const [activeTab, setActiveTab] = useState("Master Details");
    const [isSyncingCharges, setIsSyncingCharges] = useState(false);
    const tabs = ["Master Details", "Party Details", "Container Details"];
    if(masterjobStore.disable || masterjobStore.edit){
        tabs.push('Vendor Details')
        tabs.push('Charge Details')
        tabs.push('Visibility')
        tabs.push('Document Center')
    }
    const masterDetail = useForm({
        defaultValues: {
            generalDetails: {
                origin: '',
                destination: '',
                por: '',
                pol: '',
                pod: '',
                fpod: '',
                eta: '',
                etd: '',
                ata: '',
                atd: '',
                serviceCode: '',
                cargoType: ''
            },
            carrierDetails: {
                carrier: '',
                vessel: '',
                voyage: '',
                oblNo: '',
                oblDate: '',
                carrierBookingNo: '',
                carrierBookingDate: '',
                carrierBookingToggle: true,
                oblToggle: true,
            },
            notifyParty1: {
                name: '',
                agentId: '',
                buildingNo: '',
                streetName: '',
                city: '',
                state: '',
                country: '',
                poBoxNo: '',
                mobileNumber: '',
                email: '',
                branch: '',
                address: ''
            },
            notifyParty2: {
                name: '',
                agentId: '',
                buildingNo: '',
                streetName: '',
                city: '',
                state: '',
                country: '',
                poBoxNo: '',
                mobileNumber: '',
                email: '',
                branch: '',
                address: ''
            },
            shipper: {
                name: '',
                agentId: '',
                buildingNo: '',
                streetName: '',
                city: '',
                state: '',
                country: '',
                poBoxNo: '',
                mobileNumber: '',
                email: '',
                branch: '',
                address: ''
            },
            consignee: {
                name: '',
                agentId: '',
                buildingNo: '',
                streetName: '',
                city: '',
                state: '',
                country: '',
                poBoxNo: '',
                mobileNumber: '',
                email: '',
                branch: '',
                address: ''
            },
            originAgent: {
                name: '',
                agentId: '',
                buildingNo: '',
                streetName: '',
                city: '',
                state: '',
                country: '',
                poBoxNo: '',
                mobileNumber: '',
                email: '',
                branch: '',
                address: ''
            },
            destinationAgent: {
                name: '',
                agentId: '',
                buildingNo: '',
                streetName: '',
                city: '',
                state: '',
                country: '',
                poBoxNo: '',
                mobileNumber: '',
                email: '',
                branch: '',
                address: ''
            },
            containerDetails: [
                {
                    containerType: '',
                    containerNumber: '',
                    customSealNo: '',
                    actualSealNo: ''
                }
            ],
            vendorDetails:[
                {
                    vendorType:'',
                    vendorName:'',
                    transport:'',
                    vendorRefNum:'',
                    containerHandling:false,
                    containerIds:[],
                    bookingIds: [],
                }
            ],
            chargeDetails:[
                {
                    chargeName: '',
                    chargeCode: '',
                    term: '',
                    currency: '',
                    roe:'',
                    unit: '',
                    noOfUnit: '',
                    amountPerUnit: '',
                    amount:'',
                    vendorId: '',
                }
            ],
            visibilityFields: {},
            tradeType: 'Export',
            service: 'LCL',
            freight: 'Prepaid',
            masterId: '',
            shipmentScope: SHIPMENT_SCOPE.P2P
        }
    })
    const { handleSubmit, control, trigger, setValue, reset, watch, clearErrors, formState: { isDirty } } = masterDetail;
    const [isFormEdited, setIsFormEdited] = useState(false);

    useEffect(() => {
        const subscription = masterDetail.watch((value, { name }) => {
            if (name) {
                setIsFormEdited(true);
            }
        });
        return () => subscription.unsubscribe();
    }, [masterDetail]);

    
    const getFields = (data, fields) =>
        Object.fromEntries(
            fields.map(field => [field, data?.[field] ?? ""])
        );

    const getPartyDetails = (party = {}) =>
        getFields(party, ["name", "branch", "address", "buildingNo", "streetName", "city", "state", "country", "poBoxNo", "mobileNumber", "email",]
    );
    
    const generalDetailsFields = ["origin", "destination", "por", "pol", "pod", "fpod", "eta", "etd", "ata", "atd", "serviceCode", "cargoType",];

    const carrierDetailsFields = ["carrier", "vessel", "voyage", "oblDate", "oblNo", "carrierBookingDate", "carrierBookingNo",];

    useEffect(() => {
        setIsFormEdited(false);
        if (!masterjobStore.current?._id) return;

        reset({
            generalDetails: getFields( masterjobStore.current.generalDetails, generalDetailsFields), 
            carrierDetails: getFields( masterjobStore.current.carrierDetails, carrierDetailsFields),
            notifyParty1: getPartyDetails(masterjobStore.current.notifyParty1),
            notifyParty2: getPartyDetails(masterjobStore.current.notifyParty2),
            shipper: getPartyDetails(masterjobStore.current.shipper),
            consignee: getPartyDetails(masterjobStore.current.consignee),
            originAgent: getPartyDetails(masterjobStore.current.originAgent),
            destinationAgent: getPartyDetails(masterjobStore.current.destinationAgent),
            containerDetails: masterjobStore.current.containerDetails || [{
                containerType: '',
                containerNumber: '',
                customSealNo: '',
                actualSealNo: ''
            }],
            vendorDetails: (masterjobStore.current.vendorDetails || [{
                vendorType: '',
                vendorName: '',
                transport: '',
                vendorRefNum: '',
                containerHandling: false,
                bookingIds:[]
            }]),
            chargeDetails: masterjobStore.current.chargeDetails || [{
                chargeName: '',
                chargeCode: '',
                term: '',
                currency: '',
                roe: '',
                unit: '',
                noOfUnit: '',
                amountPerUnit: '',
                amount: '',
                vendorId: '',
            }],
            visibilityFields: Array.isArray(masterjobStore.current.visibilityFields)
                ? {}
                : (masterjobStore.current.visibilityFields || {}),
            tradeType: masterjobStore.current.tradeType || 'Export',
            service: masterjobStore.current.service || 'LCL',
            freight: masterjobStore.current.freight || 'Prepaid',
            masterId: masterjobStore.current.masterId || '',
            shipmentScope: masterjobStore.current.shipmentScope || SHIPMENT_SCOPE.P2P
        });

    }, [masterjobStore.current?._id, reset]);

    useEffect(() => {
        let timer;
        const lastErpSync = snapMaster.current?.erpSync?.status;
        const lastChargesSync = snapMaster.current?.chargesErpState?.lastStatus;
        const id = snapMaster.current?._id;

        if (id && (lastErpSync === "PROCESSING" || lastChargesSync === "PROCESSING")) {
            timer = setInterval(() => {
                Api.getmasterjobbyid(id, (d) => {
                    const updated = d.results?.result;
                    if (updated) {
                        if (!masterjobStore.current.erpSync) {
                            masterjobStore.current.erpSync = {};
                        }
                        masterjobStore.current.erpSync.status = updated.erpSync?.status;
                        masterjobStore.current.erpSync.syncAt = updated.erpSync?.syncAt;
                        masterjobStore.current.erpSync.syncBy = updated.erpSync?.syncBy || updated.erpSync?.syncedBy || updated.erpSync?.lastBy || masterjobStore.current.erpSync.syncBy;
                        masterjobStore.current.erpSync.remarks = updated.erpSync?.remarks;
                        if (updated.chargesErpState) {
                            masterjobStore.current.chargesErpState = {
                                ...updated.chargesErpState,
                                lastBy: updated.chargesErpState.lastBy || masterjobStore.current.chargesErpState?.lastBy
                            };
                        }
                        if (updated.masterId) {
                            masterjobStore.current.masterId = updated.masterId;
                            setValue("masterId", updated.masterId);
                        }
                    }
                });
            }, 5000);
        }

        return () => {
            if (timer) clearInterval(timer);
        };
    }, [snapMaster.current?.erpSync?.status, snapMaster.current?.chargesErpState?.lastStatus, snapMaster.current?._id]);

    const handleTabChange = async (nextTab) => {
        clearErrors()
        const shipmentScope = watch('shipmentScope')
        const pol = watch('generalDetails.pol')
        const fpod = watch('generalDetails.fpod')
        if (activeTab === "Master Details" && !masterjobStore.disable) {
            let fieldsToValidate = [
                'carrierDetails.oblNo',
                'carrierDetails.oblDate',
                'generalDetails.serviceCode',
                'carrierDetails.carrier',
                'carrierDetails.vessel',
                'carrierDetails.voyage',
                'generalDetails.eta',
                'generalDetails.etd',
            ];
            if(watch('tradeType') === 'Import'){
                fieldsToValidate.shift('carrierDetails.oblNo')
                fieldsToValidate.shift('carrierDetails.oblDate')
            }
            if (!(shipmentScope === SHIPMENT_SCOPE.P2P && pol && fpod)) {
                fieldsToValidate.unshift(
                    'generalDetails.origin',
                    'generalDetails.destination',
                    'generalDetails.por',
                    'generalDetails.pod',
                    'generalDetails.pol',
                    'generalDetails.fpod'
                );
            }
            const isValid = await trigger(fieldsToValidate);
            if (!isValid){
                configStore.setModalMessage('Please fill all mandatory fields')
                return;
            }
        }
        if(activeTab === "Party Details" && !masterjobStore.disable){
            let fieldsToValidate = []
            if (watch('tradeType') === 'Export') {
                fieldsToValidate.unshift(
                    'destinationAgent.name'
                )
            }
            if (watch('tradeType') === 'Import') {
                fieldsToValidate.unshift(
                    'originAgent.name'
                )
            }
            const isValid = await trigger(fieldsToValidate);
            if (!isValid) {
                configStore.setModalMessage('Please fill all mandatory fields')
                return;
            }
        }
        setActiveTab(nextTab);
    };
    const onSubmit = async (data) => {
        console.log("Final Form Data:", data);
        let requestPayload = {}
        if (masterjobStore.edit) {
            data.vendorDetails = data.vendorDetails.map((item) => ({
                ...item,
                containerIds: item.containerIds || [],
            }));
            requestPayload = {
                ...masterjobStore.current,
                ...data
            };
            if (configStore.modalvisibledata?.exceptionData) {
                requestPayload.visibilityFields.exceptionData = configStore.modalvisibledata.exceptionData;
            }
            const getBackendDateValue = (value) => {
                if (!value) return "";
                const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
                if (!match) return value;
                return `${match[3]}-${match[2]}-${match[1]}`;
            };
            if (activeTab === 'Visibility'){
                requestPayload.visibilityFields = Object.fromEntries(
                        Object.entries(requestPayload.visibilityFields || {}).map(
                        ([key, value]) => [
                            key,
                            visibilityDateFields.has(key)
                                ? getBackendDateValue(value)
                                : value
                        ]
                    )
                ); 
                if (requestPayload.visibilityFields?.containerlist?.length > 0) {
                    requestPayload.visibilityFields.containerlist =
                        requestPayload.visibilityFields.containerlist.map((container) =>
                            Object.fromEntries(
                                Object.entries(container).map(([key, value]) => [
                                    key,
                                    visibilityDateFields.has(key)
                                        ? getBackendDateValue(value)
                                        : value
                                ])
                            )
                        );
                }
                if(requestPayload.service === "LCL"){
                    Api.updateJobBookings({ jobId: requestPayload._id, ...requestPayload.visibilityFields })
                }
            }
        } else {
            const { vendorDetails, chargeDetails, ...rest } = data;
            requestPayload = rest
        }
        Api.addMasterJob(requestPayload, (data) => {
            configStore.setModalMessage(data.msg)
            configStore.modalvisibledata = {}
            AgmodalStore.pageVisible = false;
            AgmodalStore.apiCall = true;
        })
    };
    if(masterjobStore.linkedBookings){
        return <LinkedBookings/>
    } 
    return (
        <>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '6px' }}>
                        {snapMaster.disable ? (
                            <h2 className="title" style={{ marginBottom: 0 }}>View Master Job - {snapMaster.current._id}</h2>
                        ) : (
                            snapMaster.current._id ? (
                                <h2 className="title" style={{ marginBottom: 0 }}>Edit Master Job - {snapMaster.current._id}</h2>
                            ) : (
                                <h2 className="title" style={{ marginBottom: 0 }}>New Master Job</h2>
                            )
                        )}
                        {/* ERP Sync Status Section */}
                        {(() => {
                            const lastErpSync = masterjobStore.current?.erpSync?.status || snapMaster.current?.erpSync?.status;
                            const erpSyncAt = masterjobStore.current?.erpSync?.syncAt || snapMaster.current?.erpSync?.syncAt;
                            const erpSyncBy = masterjobStore.current?.erpSync?.syncBy || snapMaster.current?.erpSync?.syncBy || masterjobStore.current?.erpSync?.syncedBy || snapMaster.current?.erpSync?.syncedBy || masterjobStore.current?.erpSync?.lastBy || snapMaster.current?.erpSync?.lastBy;
                            const remarks = masterjobStore.current?.erpSync?.remarks || snapMaster.current?.erpSync?.remarks;
                            if (!lastErpSync && !erpSyncAt && !erpSyncBy) return null;

                            const isSuccess = lastErpSync === "SUCCESS" || lastErpSync === "SUBMITTED";
                            const isFailed = lastErpSync === "FAILED";
                            
                            const badgeBg = isSuccess ? "#e8f8f0" : isFailed ? "#fde8e8" : "#fef9c3";
                            const badgeBorder = isSuccess ? "#2ecc7140" : isFailed ? "#e74c3c40" : "#f1c40f40";
                            const textColor = isSuccess ? "#166534" : isFailed ? "#991b1b" : "#854d0e";
                            const pillColor = isSuccess ? "#2ecc71" : isFailed ? "#e74c3c" : "#f1c40f";
                            const pillBg = isSuccess ? "#dcfce7" : isFailed ? "#fee2e2" : "#fef9c3";

                            return (
                                <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                    <div style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "8px",
                                        fontSize: "11px",
                                        color: textColor,
                                        alignItems: "center",
                                        background: badgeBg,
                                        padding: "3px 8px",
                                        borderRadius: "4px",
                                        border: `1px solid ${badgeBorder}`,
                                        width: "fit-content"
                                    }}>
                                        {lastErpSync && (
                                            <div>
                                                <span style={{ fontWeight: "bold", color: textColor }}>Last ERP Sync: </span>
                                                <span style={{
                                                    background: pillBg,
                                                    color: pillColor,
                                                    padding: "2px 8px",
                                                    borderRadius: "12px",
                                                    fontWeight: "bold",
                                                    textTransform: "uppercase",
                                                    fontSize: "10px"
                                                }}>
                                                    {lastErpSync}
                                                </span>
                                            </div>
                                        )}
                                        {erpSyncAt && (
                                            <div>
                                                <span style={{ fontWeight: "bold", color: textColor }}>ERP Sync At: </span>
                                                <span style={{ fontWeight: "600" }}>
                                                    {new Date(erpSyncAt).toLocaleString()}
                                                </span>
                                            </div>
                                        )}
                                        {erpSyncBy && (
                                            <div>
                                                <span style={{ fontWeight: "bold", color: textColor }}>Synced By: </span>
                                                <span style={{ fontWeight: "600" }}>
                                                    {erpSyncBy}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                    {isFailed && remarks && (
                                        <div style={{
                                            fontSize: "10px",
                                            color: "#991b1b",
                                            background: "#fdf2f2",
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            border: "1px solid #f8b4b4",
                                            maxWidth: "350px",
                                            wordBreak: "break-word"
                                        }}>
                                            <strong>Reason:</strong> {remarks}
                                        </div>
                                    )}
                                </div>
                            );
                        })()}
                    </div>
                    {/* <button style={{ float: 'right' }} className="button is-small islink"
                        onClick={(e) => {
                            props.setOpen(false)
                            AgmodalStore.apiCall = true
                            }}>
                        <span className="icon ">
                            <i className="fas fa-xmark"></i>
                        </span>
                    </button> */}

                    <div style={{
                       display: "flex",
                       gap: "10px",
                       alignItems: "flex-end",
                       flexShrink: 0
                    }}>
                    {(() => {
                        const isJobSaved = Boolean(snapMaster.current?._id);
                        const isJobProcessing = snapMaster.current?.erpSync?.status === "PROCESSING";
                        const erpSyncAt = snapMaster.current?.erpSync?.syncAt || masterjobStore.current?.erpSync?.syncAt;
                        const isJobTimedOut = isJobProcessing && erpSyncAt && (new Date() - new Date(erpSyncAt) > 180000);
                        const isProcessing = isJobProcessing && !isJobTimedOut;
                        const currentForm = watch();
                        const formGen = currentForm?.generalDetails || {};
                        const formCar = currentForm?.carrierDetails || {};
                        const formTradeType = currentForm?.tradeType || 'Export';
                        const formScope = currentForm?.shipmentScope || SHIPMENT_SCOPE.P2P;
                        const formContainers = currentForm?.containerDetails || [];

                        // 1. Current Form mandatory checks (live state in frontend)
                        const isFormP2P = formScope === SHIPMENT_SCOPE.P2P;
                        const hasFormCommonGen = !!(formGen.serviceCode && formGen.pol && formGen.fpod && formGen.etd && formGen.eta);
                        const hasFormRouting = isFormP2P || !!(formGen.origin && formGen.destination && formGen.por && formGen.pod);
                        const hasFormCommonCarrier = !!(formCar.carrier && formCar.vessel && formCar.voyage);
                        const hasFormOblIfExport = formTradeType === 'Import' || !!(formCar.oblNo && formCar.oblDate);
                        const isFormMasterDetailsValid = hasFormCommonGen && hasFormRouting && hasFormCommonCarrier && hasFormOblIfExport;

                        const isFormPartyValid = formTradeType === 'Export'
                            ? !!(currentForm?.destinationAgent?.name?.trim())
                            : !!(currentForm?.originAgent?.name?.trim());

                        const containerPattern = /^[A-Za-z]{4}[0-9]{7}$/;
                        const isFormContainersValid = Array.isArray(formContainers) && formContainers.length > 0 && formContainers.every(c =>
                            c?.containerType && c?.containerNumber && containerPattern.test(String(c.containerNumber).trim())
                        );
                        const areFormMandatoryFieldsValid = isFormMasterDetailsValid && isFormPartyValid && isFormContainersValid;

                        // 2. Saved Database Record mandatory checks (saved state in DB)
                        const savedJob = snapMaster.current || {};
                        const savedTradeType = savedJob.tradeType || 'Export';
                        const savedScope = savedJob.shipmentScope || SHIPMENT_SCOPE.P2P;
                        const savedGen = savedJob.generalDetails || {};
                        const savedCar = savedJob.carrierDetails || {};
                        const savedContainers = savedJob.containerDetails || [];

                        const isSavedP2P = savedScope === SHIPMENT_SCOPE.P2P;
                        const hasSavedCommonGen = !!(savedGen.serviceCode && savedGen.pol && savedGen.fpod && savedGen.etd && savedGen.eta);
                        const hasSavedRouting = isSavedP2P || !!(savedGen.origin && savedGen.destination && savedGen.por && savedGen.pod);
                        const hasSavedCommonCarrier = !!(savedCar.carrier && savedCar.vessel && savedCar.voyage);
                        const hasSavedOblIfExport = savedTradeType === 'Import' || !!(savedCar.oblNo && savedCar.oblDate);
                        const isSavedMasterDetailsValid = hasSavedCommonGen && hasSavedRouting && hasSavedCommonCarrier && hasSavedOblIfExport;

                        const isSavedPartyValid = savedTradeType === 'Export'
                            ? !!(savedJob.destinationAgent?.name?.trim())
                            : !!(savedJob.originAgent?.name?.trim());

                        const isSavedContainersValid = Array.isArray(savedContainers) && savedContainers.length > 0 && savedContainers.every(c =>
                            c?.containerType && c?.containerNumber && containerPattern.test(String(c.containerNumber).trim())
                        );
                        const areSavedMandatoryFieldsValid = isSavedMasterDetailsValid && isSavedPartyValid && isSavedContainersValid;

                        // If user edited anything in the frontend, disable sync until saved
                        const hasUnsavedChanges = isFormEdited || Boolean(isDirty);

                        const isJobSyncDisabled = isProcessing || !isJobSaved || hasUnsavedChanges || !areSavedMandatoryFieldsValid || !areFormMandatoryFieldsValid;

                        let syncTitle = "";
                        if (isProcessing) {
                            syncTitle = "ERP Sync is currently processing";
                        } else if (!isJobSaved) {
                            syncTitle = "Master Job must be saved before syncing with ERP";
                        } else if (hasUnsavedChanges) {
                            syncTitle = "Please save your changes before syncing with ERP";
                        } else if (!areSavedMandatoryFieldsValid || !areFormMandatoryFieldsValid) {
                            const missing = [];
                            if (!isSavedMasterDetailsValid || !isFormMasterDetailsValid) {
                                missing.push("Master Details (Carrier/Vessel/Voyage/ETD/ETA/Service Code" + (formTradeType === 'Export' ? "/MBL No & Date" : "") + (!isFormP2P ? "/Routing" : "") + ")");
                            }
                            if (!isSavedPartyValid || !isFormPartyValid) {
                                missing.push(formTradeType === 'Export' ? "Destination Agent Name" : "Origin Agent Name");
                            }
                            if (!isSavedContainersValid || !isFormContainersValid) {
                                missing.push("Valid Container Details (Type & Container No format ABCD1234567)");
                            }
                            syncTitle = `Please fill all mandatory fields and save the job to enable ERP sync: ${missing.join(", ")}`;
                        } else {
                            syncTitle = "Sync Master Job with ERP";
                        }

                        return (
                            <button className="button "
                            disabled={isJobSyncDisabled}
                            title={syncTitle}
                            style={{
                              backgroundColor: isJobSyncDisabled ? '#e2e8f0' : '#E4F2FA',
                              color: isJobSyncDisabled ? '#94a3b8' : '#2B6ED4',
                              borderColor: isJobSyncDisabled ? '#cbd5e1' : '#2B6ED4',
                              fontSize: '14px',
                              cursor: isJobSyncDisabled ? 'not-allowed' : 'pointer'
                            }}
                            onClick={async (e) => {
                                if (isJobSyncDisabled) return;

                                const currentUser = loginStore.email || localStorage.getItem("ag_email") || "";
                                if (!masterjobStore.current.erpSync) {
                                    masterjobStore.current.erpSync = {};
                                }
                                masterjobStore.current.erpSync.status = "PROCESSING";
                                masterjobStore.current.erpSync.syncAt = new Date().toISOString();
                                if (currentUser) {
                                    masterjobStore.current.erpSync.syncBy = currentUser;
                                }
                                Api.jobErpSync(masterjobStore.current._id, masterjobStore.current.masterId, (data) => {
                                    configStore.setModalMessage(data.msg);
                                });
                            }}
                            >
                            {isProcessing ? "PROCESSING" : "Sync with ERP"}
                            </button>
                        );
                    })()}

                    {snapMaster.current?._id && (
                        <LabeledTextField disabled={masterjobStore.disable} labelStyle={{ fontSize: "12px", color: process.env.REACT_APP_ENTERPRISE_COLOUR, fontWeight: "bold" }} label="ERP Master Id" control={control} name="masterId" width={"50%"} onBlur={async (e) => {
                            if (masterjobStore.current.masterId != e && e.trim() != "") {
                                masterjobStore.current.masterId = e;
                                await Api.updatemasterid(masterjobStore.current._id, e, (data) => {
                                    configStore.setModalMessage(data.msg)
                                })
                            }
                        }} />
                    )}
                    </div>
                </div>
                
                {masterjobStore.edit ? 
                <Breadcrumbs separator=">" aria-label="breadcrumb">
                    <Link
                        underline="hover"
                        color="inherit"
                        onClick={() => {
                            resetMasterJobStore()
                            AgmodalStore.modalPage = "";
                            AgmodalStore.apiCall = true;
                            configStore.modalVisible = false;
                            AgmodalStore.pageVisible = false;
                        }}
                        sx={{ cursor: "pointer" }}
                    >
                        Master Job List
                    </Link>

                    <Typography color="#2D3E91" fontWeight={600}>
                        Edit Master Job
                    </Typography>
                </Breadcrumbs>
                :<></>}

                <div className="flex gap-2 px-4 py-2 border-solid border-[#D1D6FF] rounded-lg mt-[25px] bg-[#F4F5FF]">
                    {tabs.map((tab) => (
                        <button
                            key={tab}
                            type="button"
                            onClick={() => handleTabChange(tab)}
                            className={`flex items-center justify-center text-[15px] h-[35px] w-[full] p-4 rounded-[6px] bg-[transparent] border-[0px]`}
                            style={{
                                backgroundColor:
                                    activeTab === tab ? process.env.REACT_APP_ENTERPRISE_COLOUR : "transparent",
                                color : 
                                    activeTab === tab ? 'white':'black',
                            }}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
                <FormProvider {...masterDetail}>
                    <form onSubmit={handleSubmit(onSubmit)} onChange={() => setIsFormEdited(true)} onInput={() => setIsFormEdited(true)}>
                        {activeTab == 'Master Details' && <MasterDetails activeTab={setActiveTab} data={data} />}
                        {activeTab == 'Party Details' && <PartyDetails activeTab={setActiveTab} />}
                        {activeTab == 'Container Details' && <ContainerDetails activeTab={setActiveTab} />}
                        {activeTab == 'Vendor Details' && <VendorDetails activeTab={setActiveTab} data={masterDetail} />}
                        {activeTab == 'Charge Details' && <ChargeDetails activeTab={setActiveTab} isSyncingCharges={isSyncingCharges} setIsSyncingCharges={setIsSyncingCharges} />}
                        {activeTab == 'Document Center' && <DocumentCenter activeTab={setActiveTab} />}
                        {activeTab == 'Visibility' && <Visibility activeTab={setActiveTab} />}
                    </form>
                </FormProvider>

            </div>
        </>
    )
}

const SegmentedGroup = ({ label, options, color, active, onChange, disable }) => {
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            {label && (
                <label style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: process.env.REACT_APP_ENTERPRISE_COLOUR
                }}>
                    {label}
                </label>
            )}
            <div className="flex border-solid border-[#EBEBEB] rounded-[6px] overflow-hidden bg-white p-[2px]">
                {options.map((option) => {
                    const isActive = active === option;
                    return (
                        <button
                            key={option}
                            type="button"
                            disabled={disable}
                            style={{
                                border: "none",
                                background: isActive ? color : "white",
                                color: isActive ? "white" : "#333",
                                padding: "10px 20px",
                                borderRadius: "6px",
                                fontSize: "13px",
                                cursor: "pointer",
                            }}
                            onClick={() => onChange(option)}
                        >
                            {option}
                        </button>
                    )
                })}
            </div>
        </div>
    );
};

function MasterDetails({ activeTab, data }) {
    useSnapshot(dataListStore)
    useSnapshot(masterjobStore);
    const [chargesErpState, setChargesErpState] = useState({
        bool: false,
        booking: null
    });
    const { control, watch, setValue, getValues, trigger, clearErrors, getFieldState } = useFormContext();
    const tradeType = watch("tradeType");
    const shipmentType = watch("service");
    const paymentType = watch("freight");
    const Scope = watch("shipmentScope")
    const pol = watch('generalDetails.pol')
    const fpod = watch('generalDetails.fpod')
    const shipmentScopes = [SHIPMENT_SCOPE.P2P];
    let linkedBookingsColumn = [
        { label: "Booking Id", key: "_id" },
        { label: "Shipping Number", key: "shippingBillNo" },
        { label: "HBL Number", key: "erpBookingId" },
        { label: "Customer", key: "entityName" },
        { label: "Origin", key: "origin" },
        { label: "Destination", key: "destination" },
        { label: "Trade", key: "trade" },
        { label: "Containers", key: "containerList" },
        { label: "Status", key: "status" },
        { label: "", key: "button" },

    ];
    useEffect(() => {
        Api.getFCLCarrierList();
        Api.getMasterJobDropdown()
    }, []);

    return (
        <>
            <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px] mt-[5px]">
                <div className="flex flex-row justify-between items-start mt-[20px]">
                    <div className="flex gap-[10px]">
                        <img src={master} />
                        <p className="text-black font-bold">Master Details</p>
                    </div>
                    <div className="flex flex-row gap-[10px]">
                        <SegmentedGroup
                            label={'Product'}
                            options={["LCL", "FCL"]}
                            color={"#F0903C"}
                            active={shipmentType}
                            onChange={(data) => setValue("service", data)}
                            disable={masterjobStore.disable || masterjobStore.edit}
                        />
                        <SegmentedGroup
                            label={'Trade'}
                            options={["Export", "Import"]}
                            color={"#2B3688"}
                            active={tradeType}
                            onChange={(data) => setValue("tradeType", data)}
                            disable={masterjobStore.disable || masterjobStore.edit}
                        />
                        <SegmentedGroup
                            label={'Freight'}
                            options={["Prepaid", "Collect"]}
                            color={"#2f5edb"}
                            active={paymentType}
                            onChange={(data) => setValue("freight", data)}
                            disable={masterjobStore.disable}
                        />
                    </div>
                </div>
                {masterjobStore.disable ? <p className="text-blue-dark font-bold font-roboto">{Scope}</p> : <div className="flex flex-row gap-[20px]">
                    {shipmentScopes.map((scope) => <LabeledRadioButton label={scope} selected={Scope === scope} onClick={() => {
                        filtersState.initialize();
                        setValue('shipmentScope', scope)
                        setValue('generalDetails.origin', "")
                        setValue('generalDetails.destination', "")
                        clearErrors()
                    }} />)}
                </div>}
                <div className="flex flex-wrap gap-4 mb-[20px]">
                    {[
                        { label: "Origin", name: "generalDetails.origin", type: 'text', madatory: true, auto: true, door: Scope.split('-')[0] == 'Door' ? true : false },
                        { label: "Destination", name: "generalDetails.destination", type: 'text', madatory: true, auto: true, door: Scope.split('-')[2] == 'Door' ? true : false },
                        { label: "POR", name: "generalDetails.por", type: 'text', madatory: true, auto: true },
                        { label: "POL", name: "generalDetails.pol", type: 'text', madatory: true, auto: true },
                        { label: "POD", name: "generalDetails.pod", type: 'text', madatory: true, auto: true },
                        { label: "FPOD", name: "generalDetails.fpod", type: 'text', madatory: true, auto: true },
                        { label: "ETD", name: "generalDetails.etd", type: 'date', madatory: true },
                        { label: "ETA", name: "generalDetails.eta", type: 'date', madatory: true },
                        { label: "ATD", name: "generalDetails.atd", type: 'date' },
                        { label: "ATA", name: "generalDetails.ata", type: 'date' },
                        { label: "Service Code", name: "generalDetails.serviceCode", madatory: true, type: 'text' },
                        { label: "Cargo Type", name: "generalDetails.cargoType", type: 'text' },
                    ].map((field) => (
                        <div
                            key={field.name}
                            style={{
                                flex: "1 1 calc(25% - 16px)",
                                minWidth: 250,
                            }}
                        >
                            {
                                (field.auto) ?
                                    <Box sx={{ width: "100%", gap: "4px", display: "flex", flexDirection: "column" }}>
                                        <Typography sx={{
                                            textAlign: "start", fontFamily: "Figtree", fontSize: "12px",
                                            color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                                            fontWeight: "bold",
                                            marginBottom: '5px'
                                        }}>{field.madatory ? (
                                            <>
                                                {field.label}
                                                <span style={{ color: "red", marginLeft: 4 }}>*</span>
                                            </>
                                        ) : (
                                            field.label
                                        )}</Typography>
                                        <AgMuiUn onChange={async () => {
                                            filtersState.initialize();
                                            clearErrors()
                                            // await trigger([`${field.name}`]);
                                        }} getValues={getValues} disabled={masterjobStore.disable} clearErrors={clearErrors} trigger={trigger} validateAddress={false} getFieldState={getFieldState} placeholder={`Choose ${field.label}`} key={field.name} rules={{ required: `${field.label} is Required`}} control={control} isDoor={field.door} name={field.name} country={['POR','POL','POD','FPOD'].includes(field.label)} />
                                    </Box> :
                                    (field.label == 'Service Code' || field.label == 'Cargo Type')?
                                        <LabeledSelectField labelStyle={selectFieldLabelStyle} rules={field.label == 'Service Code' ? { required: 'Service is Required' } : {}}
                                           madatory={field.label == 'Service Code' ? true : false} disabled={masterjobStore.disable}
                                           control={control} placeholder={"Select Carrier"} options={field.label == 'Service Code' ? dataListStore['MasterJobDropownList'].filter(e => e.type === 'ServiceCode').map(e => e.serviceCode) || [] : dataListStore['MasterJobDropownList'].filter(e => e.type === 'CargoType').map(e => e.cargotype)||[]} name={field.name} label={field.label} fullwidth={true} />
                                    :
                                    <LabeledTextField
                                        labelStyle={textFieldLabelStyle}
                                        label={field.label}
                                        control={control}
                                        name={field.name}
                                        type={field.type}
                                        size="small"
                                        disabled={masterjobStore.disable}
                                        rules={field.label == 'ETA' || field.label == 'ETD' ?
                                            { required: `${field.label} is required` } : {}
                                        }
                                        madatory={field.madatory}
                                    />}
                        </div>
                    ))}
                </div>
            </div>
            <div className="flex flex-col w-full rounded-md bg-white mt-[15px] shadow-custom p-[18px] gap-[18px]">
                <div className="flex flex-row justify-between items-center mt-[20px]">
                    <div className="flex flex-row gap-[10px]">
                        <img src={carrier} />
                        <p className="text-black font-bold">Carrier Info</p>
                    </div>
                </div>
                <div className="flex flex-wrap gap-4 mb-[20px]">
                    {[
                        { label: "Carrier", name: "carrierDetails.carrier", type: 'text', madatory: true },
                        { label: "Vessel", name: "carrierDetails.vessel", type: 'text', madatory: true },
                        { label: "Voyage", name: "carrierDetails.voyage", type: 'text', madatory: true },
                        { label: "Carrier Booking Number", name: "carrierDetails.carrierBookingNo", type: 'text' },
                        { label: "Carrier Booking Date", name: "carrierDetails.carrierBookingDate", type: 'date' },
                        { label: "Carrier Booking Confirmed", name: "carrierDetails.carrierBookingToggle" },
                        { label: "MBL Number", name: "carrierDetails.oblNo", type: 'text', madatory: tradeType === 'Import' ? false : true },
                        { label: "MBL Date", name: "carrierDetails.oblDate", type: 'date', madatory: tradeType === 'Import' ? false : true },
                        { label: "OBL Confirmed", name: "carrierDetails.oblToggle" },
                    ].map((field) => (
                        <div
                            key={field.name}
                            style={{
                                flex: "0 1 calc(33.333% - 16px)",
                                minWidth: 250,
                            }}
                        >
                            {field.label == 'Carrier' || field.label == 'Vessel' ?
                                <LabeledSelectField labelStyle={selectFieldLabelStyle} rules={{ required: `${field.label} is required` }} madatory={true} disabled={masterjobStore.disable}
                                    control={control} placeholder={"Select Carrier"} options={field.label == 'Carrier' ? dataListStore["FCLCarrierList"].filter(e => e['Display Name']):dataListStore['MasterJobDropownList'].filter(e=>e.type === 'Vessel').map(e=>e.vessel)} name={field.name} label={field.label} fullwidth={true} />
                                :
                                (field.label == "Carrier Booking Confirmed" || field.label == "OBL Confirmed") ?
                                    <div className="flex items-center gap-2 m-4">
                                        <Controller
                                            name={
                                                field.label === "Carrier Booking Confirmed"
                                                    ? "carrierDetails.carrierBookingToggle"
                                                    : "carrierDetails.oblToggle"
                                            }
                                            control={control}
                                            render={({ field: controllerField }) => (
                                                <Switch
                                                    checked={controllerField.value ?? false}
                                                    onChange={(e) => controllerField.onChange(e.target.checked)}
                                                    disabled={masterjobStore.disable}
                                                />
                                            )}
                                        />
                                    </div>
                                    :
                                <LabeledTextField
                                    labelStyle={textFieldLabelStyle}
                                    disabled={masterjobStore.disable}
                                    rules={field.label == 'Vessel' || field.label == 'Voyage' || ((field.label == 'MBL Number' || field.label == 'MBL Date') && tradeType === 'Export') ?
                                        { required: `${field.label} is required` } : {}
                                    }
                                    label={field.label}
                                    control={control}
                                    name={field.name}
                                    type={field.type}
                                    size="small"
                                    madatory={field.madatory}
                                />}
                        </div>
                    ))}
                </div>
            </div>
            {(masterjobStore.edit || masterjobStore.disable) ?
                <div className="flex flex-col w-full rounded-md bg-white mt-[15px] shadow-custom p-[18px] gap-[18px]">
                    <div className="flex flex-row justify-between items-center mt-[20px]">
                        <div className="flex flex-row gap-[10px]">
                            <img src={cargoDetail} />
                            <p className="text-black font-bold">Linked Bookings ({masterjobStore?.linkedBookingData?.length})</p>
                            {masterjobStore.current?.linkedBookingErpSyncAt && (
                                <div
                                    style={{
                                        fontSize: "12px",
                                        color: "#666",
                                        lineHeight: "18px",
                                        width: "max-content",
                                        marginLeft: "5px",
                                        marginTop: "3px"
                                    }}
                                >
                                    Status:{" "}
                                    <span style={{ fontWeight: 600, textTransform: "capitalize" }}>
                                        {masterjobStore.current.lastLinkedBookingsErpSync || "-"}
                                    </span>
                                    {" | "}Synced At: {new Date(
                                        masterjobStore.current.linkedBookingErpSyncAt
                                    ).toLocaleString()}
                                    {" | "}Synced By: {masterjobStore.current.linkedBookingErpSyncdBy || "-"}
                                </div>
                            )}
                        </div>
                        <div className="flex flex-row gap-[10px]">
                        {masterjobStore.current?.service === "LCL" && masterjobStore.current?.masterId && masterjobStore?.linkedBookingData?.length>0 && 
                                (<div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "4px"
                    }}
                >
                        <button type="button" className="button"   style={{
                                padding: "8px 16px",
                                color: 'white',
                                borderRadius:'6px',
                                fontSize:'14px',
                                backgroundColor:process.env.REACT_APP_ENTERPRISE_COLOUR_TERTIARY,
                                height: "40px",
                            }} disabled={masterjobStore.current?.lastLinkedBookingsErpSync === "PROCESSING"}
                                                            onClick={(e) => {
                                                                const linkedBookingDetails = masterjobStore.current?.linkedERPBookingDetails || [];

                                                                const allLinked = linkedBookingDetails.length > 0 &&
                                                                    linkedBookingDetails.every(
                                                                        booking => booking?.erpMasterLinked === true
                                                                    );

                                                                if (allLinked) {
                                                                    configStore.setModalMessage(
                                                                        "All bookings are already linked with Erp Master Job"
                                                                    );
                                                                    return;
                                                                }
                                                                const currentUser = loginStore.email || localStorage.getItem("ag_email") || "";
                                                                
                                                                Api.jobLinkedBookingSync(masterjobStore.current._id, masterjobStore.current.masterId, (data) => {
                                                                    if (data.msg === "Request initiated") {
                                                                    masterjobStore.current.lastLinkedBookingsErpSync = "PROCESSING";
                                                                    masterjobStore.current.linkedBookingErpSyncAt = new Date().toISOString();
                                                                    if (currentUser) {
                                                                        masterjobStore.current.linkedBookingErpSyncdBy = currentUser
                                                                    }
                                                                }
                                                                    configStore.setModalMessage(data.msg);
                                                                });
                                                            }}
                                                            >
                                                            Sync Bookings with ERP
                                                            </button> 
        </div>)}
                        {masterjobStore.edit && <button
                            className="button"
                            onClick={(e) => {
                                e.preventDefault();                                
                                masterjobStore.linkedBookings = true
                            }}
                            style={{
                                padding: "8px 16px",
                                color: 'white',
                                borderRadius:'6px',
                                fontSize:'14px',
                                backgroundColor:process.env.REACT_APP_ENTERPRISE_COLOUR_TERTIARY,
                                height: "40px",
                            }}
                        >
                            + Link Bookings
                        </button>
                        }</div>
                    </div>
                    <div className="rounded-sm shadow-sm">
                        <div className="max-h-64 overflow-auto">
                            <table className="w-full">
                                <thead className="sticky top-0 z-20 border-solid border-[#DBDBDB] bg-[#F9FAFB]">
                                    <tr >
                                        {linkedBookingsColumn.map((item, index) => (
                                            <th
                                                key={index}
                                                style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}
                                                className="px-6 py-3 text-[14px] whitespace-nowrap">
                                                {item.label}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                {masterjobStore?.linkedBookingData.length > 0 ?
                                <tbody>
                                    {masterjobStore?.linkedBookingData?.map((item, index) => (
                                        <tr key={index} className="border-solid border-[#EBEBEB] bg-[#F9FAFB]">
                                            {linkedBookingsColumn.map((col, i) =>
                                                (col.key === "button") ? (
                                                    masterjobStore.edit ? (<div onClick={() => {
                                                        masterjobStore.current.linkedBookings = masterjobStore.current?.linkedBookings?.filter(id => item._id !== id)
                                                        masterjobStore.linkedBookingData = masterjobStore.linkedBookingData?.filter(booking => booking._id !== item._id)
                                                        masterjobStore.current.linkedERPBookingDetails = masterjobStore.current?.linkedERPBookingDetails?.filter(id => item._id !== id.bookingId)
                                                        masterjobStore.current.unLinkId = [...(masterjobStore.current.unLinkId || []),item._id] 
                                                        console.log(masterjobStore.current.vendorDetails,"vendorDetails123456 ********")
                                                        const updatedVendorDetails = masterjobStore.current?.vendorDetails?.map((e) => ({
                                                            ...e,
                                                            bookingIds: e?.bookingIds?.filter((id) => id !== item._id)
                                                        }));
                                                        masterjobStore.current.vendorDetails = updatedVendorDetails;
                                                        updatedVendorDetails?.forEach((vendor, vendorIndex) => {
                                                            setValue(`vendorDetails.${vendorIndex}.bookingIds`, vendor.bookingIds || []);
                                                        })
                                                    }} className="w-[35px] mt-[15px] h-full flex items-center justify-center cursor-pointer">
                                                        <img src={deleteicon} />
                                                    </div>):(<></>)
                                                ) : (
                                                    <td
                                                        key={i}
                                                        className="px-6 py-4 text-[15px] whitespace-nowrap"
                                                    >
                                                            {col.label === "Containers" ? (
                                                                    <span>{item.contract?.shipmentType?.includes("FCL") ? item?.contract?.[col.key]?.reduce(
                                                                        (sum, container) => sum + container.numContainers, 0
                                                                    ) : 1}</span>
                                                            ) 
                                                            : col.label === "Shipping Number" ? (
                                                                <span>{item[col.key]}</span>
                                                            )
                                                            : col.label === "Trade"
                                                                ? (item?.country?.toLowerCase() == item?.originCount?.toLowerCase() ? 'EXPORT' : item?.country?.toLowerCase() == item?.destinationCount?.toLowerCase() ? 'IMPORT' :"")
                                                            : ["Customer", "Origin", "Destination"].includes(col.label)
                                                                ? item.contract?.[col.key]
                                                                : item[col.key]}
                                                    </td>
                                                )
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                                :
                                <tbody>
                                  <tr>
                                    <td
                                      colSpan={linkedBookingsColumn.length}
                                      style={{
                                        textAlign: "center",
                                        padding: "20px",
                                        fontWeight: "500"
                                      }}
                                    >
                                      No data found
                                    </td>
                                  </tr>
                                </tbody>
                                }
                            </table>
                        </div>
                    </div>
                </div>
                : <></>}
            {!masterjobStore.disable ?
                <div style={{ display: "flex", gap: "10px", justifyContent: 'flex-end', marginTop: '15px' }}>
                    {masterjobStore.edit && <button className="button" type="submit" style={{
                        padding: "10px 22px",
                        height: "40px",
                        width: '100px',
                        border: `1px solid #4BA7DD`,
                    }}>
                        Save & Exit</button>}
                    <button
                        className="button"
                        onClick={async () => {
                            let fieldsToValidate = [
                                'carrierDetails.oblNo',
                                'carrierDetails.oblDate',
                                'generalDetails.serviceCode',
                                'carrierDetails.carrier',
                                'carrierDetails.vessel',
                                'carrierDetails.voyage',
                                'generalDetails.eta',
                                'generalDetails.etd',
                            ];
                            if(tradeType === 'Import'){
                                fieldsToValidate.shift('carrierDetails.oblNo')
                                fieldsToValidate.shift('carrierDetails.oblDate')
                            }
                            if (!(Scope === SHIPMENT_SCOPE.P2P && pol && fpod)) {
                                fieldsToValidate.unshift(
                                    'generalDetails.origin',
                                    'generalDetails.destination',
                                    'generalDetails.por',
                                    'generalDetails.pod',
                                    'generalDetails.pol',
                                    'generalDetails.fpod'
                                );
                            }else{
                                clearErrors([
                                    'generalDetails.origin',
                                    'generalDetails.destination',
                                    'generalDetails.por',
                                    'generalDetails.pod'
                                ])
                            }
                            const isValid = await trigger(fieldsToValidate);
                            if (isValid) activeTab('Party Details')
                                else configStore.setModalMessage('Please fill all mandatory fields in Master Details')
                        }}
                        style={{
                            padding: "10px 22px",
                            height: "40px",
                            width:'100px',
                            border: `1px solid #4BA7DD`,
                        }}
                    >
                        Next
                    </button>
                </div> : <></>}
        </>
    )
}


// function PartyDetails({ activeTab }) {
//     const { control, setValue, watch, trigger } = useFormContext();
//     const [address,setAddress] = useState()
//     const [branch, setBranch] = useState()
//     const obj = {
//         'Notify Party 1 Details':'notifyParty1',
//         'Notify Party 2 Details':'notifyParty2',
//         'Shipper Details':'shipper',
//         'Consignee Details':'consignee',
//         'Origin Agent':'originAgent',
//         'Destination Agent':'destinationAgent'
//     }
//     const fetchBranches = (entity, key) => {
//         try {
//             BranchApi.getAllBranches(entity?.entityId, (data) => {
//                 const branches = data || [];
//                 setBranch(branches)
//             });
//         } catch (e) {
//             console.log(e);
//         }
//     };
//     const clearPartyFields = (party,type) => {
//         const nameFields = ["branch", "address", "country", "state", "city", "poBoxNo"]
//         const branchFields = ["address", "country", "state", "city", "poBoxNo"]
//         const addressFields = ["city", "poBoxNo"]
//         const clearFields = type == 'Name' ? nameFields : type == 'Branch' ? branchFields : addressFields 
//         clearFields.forEach((field) =>
//             setValue(`${obj[party]}.${field}`, "")
//         );
//         if(type == 'Name'){
//             setBranch([])
//             setAddress([])
//         }
//     };
//     return (
//         <>
//         {['Notify Party 1 Details', 'Notify Party 2 Details', 'Shipper Details', 'Consignee Details', 'Origin Agent','Destination Agent'].map((party, index) => 
//             <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px] mt-[5px]">
//                 <div className="flex flex-row justify-between items-center mt-[20px]">
//                     <div className="flex flex-row gap-[10px]">
//                         <img height={'10px'} width={'15px'} src={party1} />
//                         <p className="text-black font-bold">{party}</p>
//                     </div>
//                 </div>
//                 <div className="flex flex-wrap gap-4 mb-[20px]">
//                     {[
//                         { label: "Name", name: `${obj[party]}.name`, type: 'text', placeholder: "Select Name", mandatory: (watch('tradeType') === 'Export' && `${obj[party]}` === 'destinationAgent') ? true : (watch('tradeType') === 'Import' && `${obj[party]}` === 'originAgent') ? true : false },
//                         { label: "Branch", name: `${obj[party]}.branch`, type: 'text', placeholder: "Select Branch" },
//                         // { label: "Building No", name: `${obj[party]}.buildingNo`, type: 'text', placeholder: "Enter Building No" },
//                         { label: "Address", name: `${obj[party]}.address`, type: 'text', placeholder: "Select Address" },
//                         // { label: "Street Name", name: `${obj[party]}.streetName`, type: 'text', placeholder: "Enter Street Name" },
//                         { label: "City", name: `${obj[party]}.city`, placeholder: "Enter City" },
//                         { label: "State", name: `${obj[party]}.state`, placeholder: "Enter State" },
//                         { label: "Country", name: `${obj[party]}.country`, placeholder: "Select Country" },
//                         { label: "PO Box Number", name: `${obj[party]}.poBoxNo`, type: 'text', placeholder: "Enter PO Box Number" },
//                         { label: "Mobile Number", name: `${obj[party]}.mobileNumber`, type: 'number', placeholder: "Enter Mobile Number" },
//                         { label: "Email", name: `${obj[party]}.email`, type: 'text', placeholder: "Enter Email" },

//                     ].map((field) => (
//                         <div
//                             key={field.name}
//                             style={{
//                                 flex: "0 1 calc(25% - 16px)",
//                                 minWidth: 250,
//                             }}
//                         >
//                             {(field.label == 'Name' || field.label == 'Country' || field.label == 'Address' || field.label == 'Branch' )?
//                                 <LabeledTextSelecField labelStyle={{
//                                     fontSize: "12px",
//                                     color: process.env.REACT_APP_ENTERPRISE_COLOUR,
//                                     fontWeight: "bold",
//                                     marginBottom: '1px'
//                                 }} madatory={field.mandatory} rules={field.mandatory?
//                                     { required: `${field.label} is required` } : {}
//                                 } disabled={masterjobStore.disable}
//                             control={control} callback={(e)=>{
//                                 if (field.label == 'Name'){
//                                     clearPartyFields(party,'Name')
//                                     if(e){
//                                         const entity = EntityV2Store.Cuslist.find(entity => e == entity.entityName)
//                                         fetchBranches(entity)
//                                     }
//                                 }
//                                 if(field.label == 'Branch'){
//                                     clearPartyFields(party,'Branch')
//                                     if(e){
//                                         const data = branch?.find(branch => branch.branchId == e.value)
//                                         if(data){
//                                           setAddress(data?.branchAddresses)
//                                           setValue(`${obj[party]}.state`, data?.state?.split("/")[0]);
//                                           setValue(`${obj[party]}.country`, data?.country) 
//                                         }
//                                     }
//                                 }
//                                 if(field.label == 'Address'){
//                                     clearPartyFields(party, 'Address')
//                                     if(e){
//                                         const data = address?.find(branch => branch.address == e)
//                                         if (data) {
//                                             setValue(`${obj[party]}.city`, data?.city);
//                                             setValue(`${obj[party]}.poBoxNo`, data?.pincode || data?.zipcode)
//                                         }
//                                     }
//                                 }
//                                     }} placeholder={field.placeholder} options={field.label == 'Name' ? EntityV2Store?.Cuslist?.map(e => e.entityName) :
//                                         field.label == 'Branch' ? branch?.map((r, i) => ({
//                                             value: r.branchId,
//                                             label: `${r.state?.split("/")[0]} - ${r.gst?.length ? r.gst : r.tinNum}`,
//                                         })) :
//                                         field.label == 'Address' ? address?.map(e=>e.address) :
//                                         field.label == 'Country' ? ServerLists.countryNameList  : []} name={field.name} label={field.label} fullwidth={true} />
//                            : <LabeledTextField
//                                 labelStyle={textFieldLabelStyle}
//                                 placeholder={field.placeholder}
//                                 label={field.label}
//                                 control={control}
//                                 name={field.name}
//                                 type={field.type}
//                                 size="small"
//                                 disabled={masterjobStore.disable}
//                             />}
//                         </div>
//                     ))}
//                 </div>

//             </div>
//         )}
        
//             {!masterjobStore.disable ?
//                 <div style={{ display: "flex", gap: "10px", justifyContent: 'flex-end', marginTop: '15px' }}>
//                     <ActionButton
//                         onClick={(e) => {
//                             e.preventDefault()
//                             activeTab('Master Details')
//                         }}
//                     >
//                         Previous
//                     </ActionButton>
//                     <ActionButton
//                         onClick={async (e) => {
//                             e.preventDefault()
//                             let fieldsToValidate = []
//                             if(watch('tradeType') == 'Export'){
//                                 fieldsToValidate.unshift(
//                                     "destinationAgent.name"
//                                 )
//                             }else{
//                                 fieldsToValidate.unshift(
//                                     "originAgent.name"
//                                 )
//                             }
//                             const isValid = await trigger(fieldsToValidate);
//                             if (isValid) activeTab('Container Details')
//                         }}
//                     >
//                         Next
//                     </ActionButton>
//                 </div> : <></>}
//         </>
//     )
// }

function PartySection({ party, obj }) {
    const { control, setValue, watch, trigger } = useFormContext();
    const [address, setAddress] = useState([]);
    const [branch, setBranch] = useState([]);

    useEffect(() => {
        const nameValue = watch(`${obj[party]}.name`);
        if (nameValue) {
            const entity = EntityV2Store.list.find(
                (entity) => nameValue == entity.entityName
            );
            if (entity) fetchBranches(entity);
        }
    }, []);

    useEffect(() => {
        const branchValue = watch(`${obj[party]}.branch`);
        if (branchValue && branch?.length) {
            const data = branch?.find((b) => b.branchId == branchValue?.value);
            if (data) {
                setAddress(data?.branchAddresses);
                setValue(`${obj[party]}.state`, data?.state?.split("/")[0]);
                setValue(`${obj[party]}.country`, data?.country);
            }
        }
    }, [branch]);

    useEffect(() => {
        const addressValue = watch(`${obj[party]}.address`);
        if (addressValue && address?.length) {
            const data = address?.find((a) => a.address == addressValue);
            if (data) {
                setValue(`${obj[party]}.city`, data?.city);
                setValue(`${obj[party]}.poBoxNo`, data?.pincode || data?.zipcode);
            }
        }
    }, [address]);

    const fetchBranches = (entity) => {
        try {
            BranchApi.getAllBranches(entity?.entityId, (data) => {
                setBranch(data || []);
            });
        } catch (e) {
            console.log(e);
        }
    };
    const clearPartyFields = (party,type) => {
        const nameFields = ["branch", "address", "country", "state", "city", "poBoxNo"]
        const branchFields = ["address", "country", "state", "city", "poBoxNo"]
        const addressFields = ["city", "poBoxNo"]
        const clearFields = type === 'Name' ? nameFields : type === 'Branch' ? branchFields : addressFields;
        clearFields.forEach((field) => setValue(`${obj[party]}.${field}`, ""));
        if(type == 'Name'){
            setBranch([])
            setAddress([])
        }
    };

    const fields = [
        { label: "Name", name: `${obj[party]}.name`, type: 'text', placeholder: "Select Name", mandatory: (watch('tradeType') === 'Export' && `${obj[party]}` === 'destinationAgent') ? true : (watch('tradeType') === 'Import' && `${obj[party]}` === 'originAgent') ? true : false },
        { label: "Branch", name: `${obj[party]}.branch`, type: 'text', placeholder: "Select Branch" },
        { label: "Address", name: `${obj[party]}.address`, type: 'text', placeholder: "Select Address" },
        { label: "City", name: `${obj[party]}.city`, placeholder: "Enter City" },
        { label: "State", name: `${obj[party]}.state`, placeholder: "Enter State" },
        { label: "Country", name: `${obj[party]}.country`, placeholder: "Select Country" },
        { label: "PO Box Number", name: `${obj[party]}.poBoxNo`, type: 'text', placeholder: "Enter PO Box Number" },
        { label: "Mobile Number", name: `${obj[party]}.mobileNumber`, type: 'number', placeholder: "Enter Mobile Number" },
        { label: "Email", name: `${obj[party]}.email`, type: 'text', placeholder: "Enter Email" },
    ];

    return (
        <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px] mt-[5px]">
            <div className="flex flex-row justify-between items-center mt-[20px]">
                <div className="flex flex-row gap-[10px]">
                    <img height={'10px'} width={'15px'} src={party1} />
                    <p className="text-black font-bold">{party}</p>
                </div>
            </div>

            <div className="flex flex-wrap gap-4 mb-[20px]">
                {fields.map((field) => (
                    <div key={field.name} style={{ flex: "0 1 calc(25% - 16px)", minWidth: 250 }}>
                        {['Name', 'Country', 'Address', 'Branch'].includes(field.label) ? (
                            <LabeledTextSelecField
                                labelStyle={{
                                    fontSize: "12px",
                                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                                    fontWeight: "bold",
                                    marginBottom: '1px'
                                }}
                                madatory={field.mandatory}
                                rules={field.mandatory ? { required: `${field.label} is required` } : {}}
                                disabled={masterjobStore.disable}
                                control={control}
                                callback={(e) => {
                                    if (field.label === 'Name') {
                                        clearPartyFields('Name');
                                        if (e) {
                                            const entity = EntityV2Store.list.find(entity => e == entity.entityName);
                                            setValue(`${obj[party]}.agentId`, entity?.erpnumber || "");
                                            fetchBranches(entity);
                                        }
                                    }
                                    if (field.label === 'Branch') {
                                        clearPartyFields('Branch');
                                        if (e) {
                                            const data = branch?.find(b => b.branchId == e.value);
                                            if (data) {
                                                setAddress(data?.branchAddresses);
                                                setValue(`${obj[party]}.state`, data?.state?.split("/")[0]);
                                                setValue(`${obj[party]}.country`, data?.country);
                                            }
                                        }
                                    }
                                    if (field.label === 'Address') {
                                        clearPartyFields('Address');
                                        if (e) {
                                            const data = address?.find(a => a.address == e);
                                            if (data) {
                                                setValue(`${obj[party]}.city`, data?.city);
                                                setValue(`${obj[party]}.poBoxNo`, data?.pincode || data?.zipcode);
                                            }
                                        }
                                    }
                                }}
                                placeholder={field.placeholder}
                                options={
                                    field.label === 'Name' ? EntityV2Store?.list?.filter(e => e.status !== "DEACTIVATED" && e.status !== "REJECTED").map(e => e.entityName) :
                                        field.label === 'Branch' ? branch?.map((r) => ({ value: r.branchId, label: `${r.state?.split("/")[0]} - ${r.gst?.length ? r.gst : r.tinNum}` })) :
                                            field.label === 'Address' ? address?.map(e => e.address) :
                                                field.label === 'Country' ? ServerLists.countryNameList : []
                                }
                                name={field.name}
                                label={field.label}
                                fullwidth={true}
                            />
                        ) : (
                            <LabeledTextField
                                labelStyle={textFieldLabelStyle}
                                placeholder={field.placeholder}
                                label={field.label}
                                control={control}
                                name={field.name}
                                type={field.type}
                                size="small"
                                disabled={masterjobStore.disable}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

function PartyDetails({ activeTab }) {
    const { watch, trigger } = useFormContext();

    const obj = {
        'Notify Party 1 Details': 'notifyParty1',
        'Notify Party 2 Details': 'notifyParty2',
        'Shipper Details': 'shipper',
        'Consignee Details': 'consignee',
        'Origin Agent': 'originAgent',
        'Destination Agent': 'destinationAgent',
    };

    const parties = [
        'Notify Party 1 Details',
        'Notify Party 2 Details',
        'Shipper Details',
        'Consignee Details',
        'Origin Agent',
        'Destination Agent',
    ];

    return (
        <>
            {parties.map((party) => (
                <PartySection key={party} party={party} obj={obj} />
            ))}

            {!masterjobStore.disable && (
                <div style={{ display: "flex", gap: "10px", justifyContent: 'flex-end', marginTop: '15px' }}>
                    {masterjobStore.edit && (
                        <button className="button" type="submit" style={{
                            padding: "10px 22px",
                            height: "40px",
                            width: '100px',
                            border: `1px solid #4BA7DD`,
                        }}>
                        Save & Exit</button>
                    )}
                    <ActionButton onClick={(e) => { e.preventDefault(); activeTab('Master Details'); }}>
                        Previous
                    </ActionButton>
                    <ActionButton
                        onClick={async (e) => {
                            e.preventDefault();
                            let fieldsToValidate = [];
                            if(watch('tradeType') === 'Export') {
                                fieldsToValidate.unshift("destinationAgent.name");
                            }else{
                                fieldsToValidate.unshift("originAgent.name");
                            }
                            const isValid = await trigger(fieldsToValidate);
                            if (isValid) activeTab('Container Details');
                                else configStore.setModalMessage('Please fill all mandatory fields in Party Details')
                        }}
                    >
                        Next
                    </ActionButton>
                </div>
            )}
        </>
    );
}

function ContainerDetails({ activeTab }) {
    const { control, setValue, trigger } = useFormContext();
    const { fields, append, remove } = useFieldArray({
        control,
        name: "containerDetails",
    });
    const containerTypeList = [`20'STD`, `40'STD`, `40'HC`]
    return (
        <>
            <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px] mt-[5px]">
                <div className="flex flex-row justify-between items-center mt-[20px]">
                    <div className="flex flex-row gap-[10px]">
                        <img src={cargoDetail} />
                        <p className="text-black font-bold">Container Details</p>
                    </div>
                </div>
                <div>
                    {fields.map((item, index) => (
                        <div
                            key={item.id}
                            style={{
                                display: "flex",
                                gap: 16,
                                marginBottom: 12,
                                padding: 12,
                            }}
                        >
                            {[
                                { label: "Container Type", name: "containerType" },
                                { label: "Container Number", name: "containerNumber", madatory: true },
                                { label: "Custom Seal No", name: "customSealNo" },
                                { label: "Agent Seal No", name: "actualSealNo" },
                            ].map((field) => (
                                field.label == 'Container Type' ?
                                    <LabeledSelectField labelStyle={selectFieldLabelStyle}
                                        disabled={masterjobStore.disable} control={control} rules={{ required: "Container Type is required" }} placeholder={"Select Container Type"} options={containerTypeList} name={`containerDetails.${index}.${field.name}`} label={field.label} width={'30%'} madatory={true} /> :
                                    <div
                                        key={field.name}
                                        style={{
                                            flex: "1 1 calc(33.333% - 16px)",
                                            minWidth: 220,
                                        }}
                                    >
                                        <LabeledTextField
                                            labelStyle={textFieldLabelStyle}
                                            disabled={masterjobStore.disable}
                                            madatory={field.madatory}
                                            callback={(e)=>{
                                                if (field.label == "Container Number"){
                                                    setValue(`containerDetails.${index}.${field.name}`, e?.toUpperCase())
                                                }
                                            }}
                                            rules={
                                                field.label === "Container Number"
                                                    ? {
                                                        required: "Container Number is required.(Format:ABCD1234567)",
                                                        pattern: {
                                                            value: /^[A-Za-z]{4}[0-9]{7}$/,
                                                            message: "Invalid format. Must be 4 letters followed by 7 numbers (ABCD1234567)."
                                                        }
                                                    }
                                                    : {}
                                            }
                                            label={field.label}
                                            control={control}
                                            name={`containerDetails.${index}.${field.name}`}
                                            size="small"
                                        />
                                    </div>
                            ))}
                            {index != 0 && !masterjobStore.disable ? <div onClick={() => { remove(index) }} className="w-[35px] mt-[30px] h-full flex items-center justify-center cursor-pointer">
                                <img src={deleteicon} />
                            </div> : <div className="w-[35px] mt-[30px] h-full flex items-center justify-center"></div>}
                        </div>
                    ))}
                    {!masterjobStore.disable ?
                        <div style={{ display: "flex", gap: "10px", justifyContent: 'flex-end', marginRight: '50px' }}><button
                            className="button"
                            onClick={() => {
                                append({
                                    containerType: '',
                                    containerNumber: '',
                                    customSealNo: '',
                                    actualSealNo: ''
                                })
                            }}
                            style={{
                                padding: "8px 16px",
                                color: '#2B3688',
                                height: "40px",
                                backgroundColor:'#F9FAFB',
                                border: `1px solid #2B3688`,
                                fontSize:'15px',
                                fontFamily:'figtree'
                            }}
                        >
                            + Add Container
                        </button>
                        </div> : <></>}
                </div>
            </div>
            {(!masterjobStore.disable) ?
                <div style={{ display: "flex", gap: "10px", justifyContent: 'flex-end', marginTop: '15px' }}>
                    {masterjobStore.edit && (
                        <button className="button" type="submit" style={{
                            padding: "10px 22px",
                            height: "40px",
                            width: '100px',
                            border: `1px solid #4BA7DD`,
                        }}>
                            Save & Exit</button>
                    )}
                    <ActionButton
                        onClick={(e) => {
                            e.preventDefault()
                            activeTab('Party Details')
                        }}
                    >
                        Previous
                    </ActionButton>
                    {(masterjobStore.edit) ?
                    <ActionButton
                        onClick={async (e) => {
                            e.preventDefault()
                            const fieldsToValidate = fields.flatMap((_, index) => [
                                `containerDetails.${index}.containerType`,
                                `containerDetails.${index}.containerNumber`,
                            ])
                            const isValid = fieldsToValidate.length > 0 && await trigger(fieldsToValidate)
                            if (isValid) activeTab('Vendor Details')
                                else configStore.setModalMessage('Please fill all mandatory fields in Container Details')
                        }}
                    >
                        Next
                    </ActionButton>
                    :
                    <button
                        className="button"
                        type="submit"
                        style={{
                            padding: "8px 16px",
                            color: 'white',
                            backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                            height: "40px",
                            border: `1px solid`,
                        }}
                    >
                        Save
                    </button>}
                </div> : <></>}
        </>
    )
}

function VendorDetails({ activeTab,data }) {
    const { control,register, watch, getValues } = useFormContext();
    const { fields, append, remove } = useFieldArray({
        control,
        name: "vendorDetails",
    });
    const vendorsList = ['Origin Transport', 'Origin Warehouse', 'OriginCFS Operator', 'Origin Customs Clearance', 'LCL Consolidator', 'Ocean Carrier', 'BL Release', 'DO Release', 'Destination Customs Clearance', 'DestinationCFS Operator', 'IOR Vendor', 'Destination Warehouse', 'Destination Transport', 'Lashingand Chocking', 'Fumigation', 'Survey']
    return (
      <>
        <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px] mt-[5px]">
          <div className="flex flex-row justify-between items-center mt-[20px]">
            <div className="flex flex-row gap-[10px]">
              <img src={party1} />
              <p className="text-black font-bold">Vendor Details</p>
            </div>
          </div>

          {fields.map((vendor, index) => (            
            <div
              key={vendor.id}
              className="border border-[#E5E7EB] rounded-md p-4 bg-white shadow-custom"
              style={{
                  gap: 16,
                  marginBottom: 12,
                  padding: 12,
              }}
            >
                  
              <div className="flex justify-between items-start">
                      <div className="grid grid-cols-4 gap-4 flex-1">
                          {[
                              { label: "Vendor Type", name: "vendorType", type: "select",disable:masterjobStore.disable },
                            //   { label: "Transport", name: "transport", type: "transport" },
                              { label: "Vendor Name", name: "vendorName", type: "select", disable: masterjobStore.disable },
                              { label: "Vendor Ref Number", name: "vendorRefNum", type: "text", disable: masterjobStore.disable },
                              { label: "Container Handling", name: "containerHandling", type: "checkbox", disable: masterjobStore.disable },
                              { label: "Select Bookings", name: "bookingIds", type: "multiselect", disable: masterjobStore.disable },
                              ...(watch(`vendorDetails.${index}.containerHandling`) ? [{ label: "Select Containers", name: "containerIds", type: "multiselect", disable: masterjobStore.disable }] : []),
                          ].map((field) => (
                              <div key={field.name}>
                                  {field.type === "select" && (
                                      <LabeledSelectField
                                          labelStyle={selectFieldLabelStyle}
                                          control={control}
                                          name={`vendorDetails.${index}.${field.name}`}
                                          label={field.label}
                                          disabled={field.disable}
                                          options={
                                              field.name === "vendorType"
                                                  ? vendorsList
                                                  : EntityV2Store?.list?.filter(e => e.status !== "DEACTIVATED" && e.status !== "REJECTED")?.map(e => e.entityName)
                                          }
                                      />
                                  )}  

                                  {field.type === "multiselect" && (
                                      <LabeledMultiSelectField
                                          labelStyle={selectFieldLabelStyle}
                                          control={control}
                                          name={`vendorDetails.${index}.${field.name}`}
                                          label={field.label}
                                          disabled={field.disable}
                                          multiple={true}
                                          options={
                                                field.label === "Select Bookings" ? (masterjobStore?.linkedBookingData?.map((booking) => booking._id) || [])
                                                  : (getValues("containerDetails")?.map(
                                                      (container) => container.containerType
                                                  ) || [])
                                          } />
                                  )}

                                  {field.type === "text" && (
                                      <LabeledTextField
                                          labelStyle={textFieldLabelStyle}
                                          disabled={field.disable}
                                          control={control}
                                          name={`vendorDetails.${index}.${field.name}`}
                                          label={field.label}
                                      />
                                  )}

                                  {field.type === "checkbox" && (
                                      <div className="flex flex-col">
                                          <label style={textFieldLabelStyle}>
                                              {field.label}
                                          </label>

                                          <input
                                              className="self-start"
                                              disabled={field.disable}
                                              type="checkbox"
                                              style={{marginTop:'10px'}}
                                              {...register(
                                                  `vendorDetails.${index}.${field.name}`
                                              )}
                                          />
                                      </div>
                                  )}
                              </div>
                          ))}
                          {['Origin Transport', 'Destination Transport'].includes(watch(`vendorDetails.${index}.vendorType`)) && <LabeledSelectField
                              labelStyle={selectFieldLabelStyle}
                              control={control}
                              name={`vendorDetails.${index}.transport`}
                              label={'Transport'}
                              disabled={masterjobStore.disable}
                              options={['Dryage','LTL','FTL']}
                          />}
                      </div>

                {(index > 0 && masterjobStore.edit) && (
                    <div onClick={() => { remove(index) }} className="w-[40px] h-[40px] ml-[10px] mt-[20px] bg-[#FFE5E5] flex items-center justify-center cursor-pointer">
                        <img className="w-[22px] h-[22px]" src={deleteicon} />
                    </div>  
                )}
              </div>
              {masterjobStore.linkedBookingData?.length > 0 && (
                  <div className="mt-4">
                    <p className="text-[12px] text-[#E87A1A] mb-2">
                      {watch(`vendorDetails.${index}.bookingIds`)?.length || 0} Bookings
                      applicable for this vendor
                    </p>           
                    <div className="flex flex-wrap gap-2">
                      {masterjobStore?.linkedBookingData
                        ?.filter((booking) =>
                          watch(`vendorDetails.${index}.bookingIds`)?.includes(booking._id))
                        ?.map((booking) => (
                          <label
                            key={booking._id}
                            className="flex items-center w-[200px] h-[45px] gap-2 bg-[#F5F6FF] px-4 py-3 rounded text-[13px]"
                            style={{
                              backgroundColor: "#F5F6FF",
                              color: "#2B6ED4",
                            }}
                          >
                            {booking._id}
                          </label>
                        ))}
                    </div>
                  </div>
               )}
                  {watch(`vendorDetails.${index}.containerHandling`) && (
                      <div className="mt-4">
                          <p className="text-[12px] text-[#E87A1A] mb-2">
                              {watch(`vendorDetails.${index}.containerIds`)?.length} Containers applicable for this vendor
                          </p>

                          <div className="flex flex-wrap gap-2">
                              {getValues("containerDetails")
                                  ?.filter((container) =>
                                      watch(`vendorDetails.${index}.containerIds`)?.includes(container.containerType)
                                  )
                                  .map((container) => (
                                      <label
                                          key={container.containerType}
                                          className="flex items-center gap-2 bg-[#F5F6FF] px-4 py-3 rounded text-[13px] text-[#2B6ED4]"
                                      >
                                          {`${container.containerType}(${container.containerNumber})`}
                                      </label>
                                  ))}
                          </div>
                      </div>
                  )}
            </div>
          ))}

        {masterjobStore.edit &&<div className="flex justify-end">
            <button
              type="button"
              className="button"
              onClick={() =>
                append({
                  vendorType: "",
                  vendorName: "",
                  transport: '',
                  vendorRefNum: "",
                  containerHandling: false,
                  containerIds:[],
                  bookingIds: [],
                })
              }
              style={{
                  padding: "8px 16px",
                  color: '#2B3688',
                  height: "40px",
                  backgroundColor: '#F9FAFB',
                  border: `1px solid #2B3688`,
                  fontSize: '15px',
                  fontFamily: 'figtree'
              }}
            >
              + Add Vendor
            </button>
          </div>}
        </div>
        {!masterjobStore.disable ? (
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "flex-end",
              marginTop: "15px",
            }}
          >
            {masterjobStore.edit && (
              <button className="button" type="submit" style={{
                padding: "10px 22px",
                height: "40px",
                width: '100px',
                border: `1px solid #4BA7DD`,
            }}>
                Save & Exit</button>
            )}
            <ActionButton
              onClick={(e) => {
                e.preventDefault();
                activeTab("Container Details");
              }}
            >
              Previous
            </ActionButton>
            <ActionButton
              onClick={(e) => {
                e.preventDefault();
                activeTab("Charge Details");
              }}
            >
              Next
            </ActionButton>
          </div>
        ) : (
          <></>
        )}
      </>
    );
}


function ChargeDetails({ activeTab, isSyncingCharges, setIsSyncingCharges }) {
    useSnapshot(masterjobStore)
    const snapMaster = useSnapshot(masterjobStore);
    const [totalAmount,setTotalAmount] = useState(0.00)
    const [total,setTotal] = useState()
    const [open,setOpen] = useState(false)
    const { control,setValue,watch } = useFormContext();
    const { fields, append, remove } = useFieldArray({
        control,
        name: "chargeDetails",
    });
    const shipmentType = watch('service')
    const unitValues = ['KG(s)', 'CBM(s)', 'CONTAINER(s)', 'SHIPMENT(s)']
    const chargeDetails = watch("chargeDetails");

    useEffect(() => {
      const toNum = (v) => Number(String(v ?? "").replace(/,/g, "")) || 0;
      chargeDetails?.forEach((row, index) => {
        const amount = (toNum(row.noOfUnit) || 0) * (toNum(row.amountPerUnit) || 0);
        setValue(`chargeDetails.${index}.amount`, amount.toFixed(2));
        setTotalAmount(chargeDetails.reduce((sum, row) => {
            return sum + (Number(row.amount) * row.roe || 0);
        }, 0))
      });
    }, [JSON.stringify(chargeDetails)]);

    useEffect(()=>{
        setTotal(masterjobStore.linkedBookingData.reduce(
            (acc, item) => {
                acc.totalWeight += item.contract.cargoTotals?.totTotalWeight || 0;
                acc.totalVolume += item.contract.cargoTotals?.totTotalVolume || 0;
                acc.totalPackages += item.contract.cargoTotals?.totNumPackages || 0;
                return acc;
            },
            {
                totalWeight: 0,
                totalVolume: 0,
                totalPackages: 0
            }
        ))
        
    },[])

    const getTotalUnit = (unit)=>{
        if(unit == 'CBM'){
            return total.totalVolume
        } else if (unit == 'KG') {
            return total.totalWeight
        } else if (unit == 'Container') {
            return 1
        }else{
            return 1
        }
    }

    const getCalculatedValues = (unit,noOfUnit,amount,data)=>{
        if(unit == 'CBM' || unit == 'KG'){
            const totalValue = unit == 'CBM' ? data.totTotalVolume : data.totTotalWeight
            return (amount /noOfUnit) * totalValue
        }else{
            return amount / masterjobStore.linkedBookingData?.length
        }
    }

    const sanitizeNumberDot = (val) => {
        if (val === undefined || val === null) return "";
        let str = String(val).replace(/[^0-9.]/g, "");
        const firstDotIndex = str.indexOf(".");
        if (firstDotIndex !== -1) {
            str = str.slice(0, firstDotIndex + 1) + str.slice(firstDotIndex + 1).replace(/\./g, "");
        }
        return str;
    };

    const handleNumberDotKeyDown = (e) => {
        const allowedControlKeys = [
            "Backspace", "Delete", "Tab", "Escape", "Enter",
            "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown",
            "Home", "End"
        ];
        if (allowedControlKeys.includes(e.key)) {
            return;
        }
        if (e.ctrlKey || e.metaKey) {
            return;
        }
        if (/^[0-9]$/.test(e.key)) {
            return;
        }
        if (e.key === ".") {
            const input = e.target;
            const val = input.value || "";
            const selStart = input.selectionStart ?? 0;
            const selEnd = input.selectionEnd ?? 0;
            const selectedText = val.substring(selStart, selEnd);
            if (!val.includes(".") || selectedText.includes(".")) {
                return;
            }
        }
        e.preventDefault();
    };

    const handleNumberDotPaste = (e, fieldName, index) => {
        e.preventDefault();
        const paste = (e.clipboardData || window.clipboardData)?.getData("text") || "";
        const sanitizedPaste = sanitizeNumberDot(paste);
        const input = e.target;
        const val = input.value || "";
        const selStart = input.selectionStart ?? 0;
        const selEnd = input.selectionEnd ?? 0;
        const combined = val.slice(0, selStart) + sanitizedPaste + val.slice(selEnd);
        const finalCleaned = sanitizeNumberDot(combined);
        setValue(`chargeDetails.${index}.${fieldName}`, finalCleaned);
    };

    return(
        <>
            <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px] mt-[5px]">
                <div className="flex flex-row justify-between items-center mt-[20px]">
                    <div className="flex flex-row">
                        <img src={dollar} />
                        <p className="text-black font-bold">Charge Details</p>
                    </div>
                    {/* Sync Charges Button and Status */}
                    {snapMaster.current?._id && (
                        <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                            {(() => {
                                const lastChargesSync = snapMaster.current?.chargesErpState?.lastStatus || masterjobStore.current?.chargesErpState?.lastStatus;
                                const chargesSyncAt = snapMaster.current?.chargesErpState?.lastAt || masterjobStore.current?.chargesErpState?.lastAt;
                                const chargesSyncBy = snapMaster.current?.chargesErpState?.lastBy || masterjobStore.current?.chargesErpState?.lastBy || snapMaster.current?.chargesErpState?.syncBy || masterjobStore.current?.chargesErpState?.syncBy;
                                const remarks = snapMaster.current?.chargesErpState?.remarks || masterjobStore.current?.chargesErpState?.remarks;
                                if (!lastChargesSync && !chargesSyncAt && !chargesSyncBy) return null;

                                const isSuccess = lastChargesSync === "SUCCESS";
                                const isFailed = lastChargesSync === "FAILED";
                                
                                const badgeBg = isSuccess ? "#e8f8f0" : isFailed ? "#fde8e8" : "#fef9c3";
                                const badgeBorder = isSuccess ? "#2ecc7140" : isFailed ? "#e74c3c40" : "#f1c40f40";
                                const textColor = isSuccess ? "#166534" : isFailed ? "#991b1b" : "#854d0e";
                                const pillColor = isSuccess ? "#2ecc71" : isFailed ? "#e74c3c" : "#f1c40f";
                                const pillBg = isSuccess ? "#dcfce7" : isFailed ? "#fee2e2" : "#fef9c3";

                                return (
                                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                        <div style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: "10px",
                                            fontSize: "11px",
                                            color: textColor,
                                            alignItems: "center",
                                            background: badgeBg,
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            border: `1px solid ${badgeBorder}`
                                        }}>
                                            {lastChargesSync && (
                                                <div>
                                                    <span style={{ fontWeight: "bold", color: textColor }}>Sync: </span>
                                                    <span style={{
                                                        background: pillBg,
                                                        color: pillColor,
                                                        padding: "2px 8px",
                                                        borderRadius: "12px",
                                                        fontWeight: "bold",
                                                        textTransform: "uppercase",
                                                        fontSize: "9px"
                                                    }}>
                                                        {lastChargesSync}
                                                    </span>
                                                </div>
                                            )}
                                            {chargesSyncAt && (
                                                <div>
                                                    <span style={{ fontWeight: "600" }}>
                                                        {new Date(chargesSyncAt).toLocaleString()}
                                                    </span>
                                                </div>
                                            )}
                                            {chargesSyncBy && (
                                                <div>
                                                    <span style={{ fontWeight: "bold", color: textColor }}>Synced By: </span>
                                                    <span style={{ fontWeight: "600" }}>
                                                        {chargesSyncBy}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        {isFailed && remarks && (
                                            <div style={{
                                                fontSize: "10px",
                                                color: "#991b1b",
                                                background: "#fdf2f2",
                                                padding: "4px 8px",
                                                borderRadius: "4px",
                                                border: "1px solid #f8b4b4",
                                                maxWidth: "350px",
                                                wordBreak: "break-word"
                                            }}>
                                                <strong>Reason:</strong> {remarks}
                                            </div>
                                        )}
                                    </div>
                                );
                            })()}
                            {(() => {
                                const isChargesProcessing = snapMaster.current?.chargesErpState?.lastStatus === "PROCESSING";
                                const chargesSyncAt = snapMaster.current?.chargesErpState?.lastAt || masterjobStore.current?.chargesErpState?.lastAt;
                                const isChargesTimedOut = isChargesProcessing && chargesSyncAt && (new Date() - new Date(chargesSyncAt) > 180000);
                                const formMasterId = masterjobStore.current?.masterId || snapMaster.current?.masterId || watch("masterId");
                                const isChargesSyncDisabled = isSyncingCharges || (isChargesProcessing && !isChargesTimedOut) || !formMasterId || !String(formMasterId).trim();

                                return (
                                    <button className="button"
                                    disabled={isChargesSyncDisabled}
                                    style={{
                                      backgroundColor: isChargesSyncDisabled ? '#e2e8f0' : '#E4F2FA',
                                      color: isChargesSyncDisabled ? '#94a3b8' : '#2B6ED4',
                                      borderColor: isChargesSyncDisabled ? '#cbd5e1' : '#2B6ED4',
                                      fontSize: '14px',
                                      cursor: isChargesSyncDisabled ? 'not-allowed' : 'pointer',
                                      padding: "6px 12px",
                                      borderRadius: "4px"
                                    }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        // Validate all fields in each row
                                        const requiredKeys = [
                                            "chargeName",
                                            "chargeCode",
                                            "term",
                                            "currency",
                                            "unit",
                                            "noOfUnit",
                                            "amountPerUnit",
                                            "vendor"
                                        ];
                                        if (!chargeDetails || chargeDetails.length === 0) {
                                            configStore.setModalMessage("No charges found to sync.");
                                            return;
                                        }
                                        for (let i = 0; i < chargeDetails.length; i++) {
                                            const row = chargeDetails[i] || {};
                                            const isRowValid = requiredKeys.every(key => {
                                                const val = row[key];
                                                return val !== undefined && val !== null && String(val).trim() !== "";
                                            });
                                            const roeValid = row.currency === "INR" || (row.roe !== undefined && row.roe !== null && String(row.roe).trim() !== "");
                                            
                                            if (!isRowValid || !roeValid) {
                                                configStore.setModalMessage(`Please fill all fields for row ${i + 1}. All fields in a row are mandatory.`);
                                                return;
                                            }
                                        }

                                        const currentUser = loginStore.email || localStorage.getItem("ag_email") || "";
                                        if (!masterjobStore.current.chargesErpState) {
                                            masterjobStore.current.chargesErpState = {};
                                        }
                                        masterjobStore.current.chargesErpState.lastStatus = "PROCESSING";
                                        masterjobStore.current.chargesErpState.lastAt = new Date().toISOString();
                                        if (currentUser) {
                                            masterjobStore.current.chargesErpState.lastBy = currentUser;
                                        }
                                        setIsSyncingCharges(true);
                                        try {
                                            Api.chargesErpSync(snapMaster.current._id, (data) => {
                                                setIsSyncingCharges(false);
                                                // Update state directly on success/initiated response if returned
                                                if (data?.chargesErpState) {
                                                    masterjobStore.current.chargesErpState = {
                                                        ...data.chargesErpState,
                                                        lastBy: data.chargesErpState.lastBy || masterjobStore.current.chargesErpState?.lastBy || currentUser
                                                    };
                                                }
                                                configStore.setModalMessage(data.msg);
                                            }, "job");
                                        } catch (err) {
                                            setIsSyncingCharges(false);
                                            masterjobStore.current.chargesErpState.lastStatus = "FAILED";
                                            console.error(err);
                                            configStore.setModalMessage("Error initiating sync.");
                                        }
                                    }}
                                    >
                                    {(isChargesProcessing && !isChargesTimedOut) ? "PROCESSING" : `Sync Charges${!formMasterId || !String(formMasterId).trim() ? " (No ID)" : ""}`}
                                    </button>
                                );
                            })()}
                        </div>
                    )}
                    <div style={{ display: "flex", gap: "10px", justifyContent: 'flex-start', marginRight: '50px' }}><button
                        className="button"
                        disabled={masterjobStore.current?.chargeDetails?.every(e => e.proRate) || !masterjobStore.current?.chargeDetails?.every(item =>
                            Object.entries(item)
                                .filter(([key]) => key !== "vendorId")
                                .every(([, value]) => value !== "")
                        )}
                        onClick={(e) => {
                            e.preventDefault();
                            setOpen(true)
                        }}
                        style={{
                            padding: "8px 16px",
                            color: '#2B3688',
                            height: "40px",
                            backgroundColor: '#F9FAFB',
                            border: `1px solid #2B3688`,
                            fontSize: '15px',
                            fontFamily: 'figtree'
                        }}
                    >
                        Pro Rate 
                    </button>
                    </div>
                    {open ? <Popup successBtn={"Ok, Pro Rate"} content={"Pro Rating will distribute the cost proportionately across all shipments linked to the Master Job. Please ensure that all relevant shipments are linked before proceeding with Pro Rating. Once the cost has been Pro Rated, you will not be able to make any changes to the linked bookings."}  
                    onSubmit={() => {
                        const bookingList = masterjobStore?.linkedBookingData
                        const isValid = chargeDetails.every(charge =>
                            Object.entries(charge).every(([key, value]) => {
                                if (key === "vendorId") return true;

                                return value !== "" &&
                                    value !== null &&
                                    value !== undefined;
                            })
                        );
                        if (bookingList?.length > 0) {
                            for (const charge of chargeDetails) {
                                if (!charge.proRate) {
                                    if (!isValid) {
                                        configStore.setModalMessage("Please check all  the fields")
                                        return;
                                    }
                                    for (const booking of bookingList) {

                                        booking.contract.chargesErp ??= [];

                                        const entity = EntityV2Store?.list?.find(
                                            e => e.entityName === charge.vendor
                                        );

                                        booking.contract.chargesErp.push({
                                            chargeCode: charge.chargeCode,
                                            chargeName: charge.chargeName,
                                            term: charge.term,
                                            unit: charge.unit,
                                            noOfUnit: charge.unit == 'CBM' ? booking.contract.cargoTotals?.totTotalVolume : charge.unit == 'KG' ? booking.contract.cargoTotals?.totTotalWeight : 1,
                                            currency: "INR",
                                            roe: 0,
                                            amountPerUnit: 0,
                                            billToCustomer: "",
                                            billToId: booking?.contract?.entityId,
                                            costCurrency: charge.currency,
                                            costRoe: charge.roe,
                                            costPerUnit: charge.amountPerUnit,
                                            vendorId: entity?.entityId,
                                            amount: 0,
                                            localAmount: 0,
                                            costAmount: getCalculatedValues(charge.unit, charge.noOfUnit, charge.amount, booking.contract.cargoTotals),
                                            costLocalAmount: getCalculatedValues(charge.unit, charge.noOfUnit, charge.amount, booking.contract.cargoTotals),
                                            job: true,
                                            createdOn: new Date().toISOString(),
                                            createdBy: loginStore.userRec.email || "",
                                        });
                                        Api.updateProRateBookings({ id: booking._id, chargesErp: booking.contract.chargesErp })
                                    }
                                    charge["proRate"] = true
                                }
                            }
                            setOpen(false)
                        } else {
                            setOpen(false)
                            configStore.setModalMessage("No Linked Bookings Found")
                        }
                    }} onClose={()=>setOpen(false)}/>:<></>}
                </div>
                <div>
                    {fields.map((item, index) => {
                        const otherSelectedCodes = new Set(
                            (chargeDetails || [])
                                .filter((_, idx) => idx !== index)
                                .map(c => {
                                    if (c?.chargeCode) return c.chargeCode;
                                    if (c?.chargeName) {
                                        const found = configStore.chargeDescriptionList?.find(f => f._id === c.chargeName);
                                        return found?.chargeCode;
                                    }
                                    return null;
                                })
                                .filter(Boolean)
                        );
                        const otherSelectedNames = new Set(
                            (chargeDetails || [])
                                .filter((_, idx) => idx !== index)
                                .map(c => {
                                    if (c?.chargeName) return c.chargeName;
                                    if (c?.chargeCode) {
                                        const found = configStore.chargeDescriptionList?.find(f => f.chargeCode === c.chargeCode);
                                        return found?._id;
                                    }
                                    return null;
                                })
                                .filter(Boolean)
                        );
                        const currentChargeCode = watch(`chargeDetails.${index}.chargeCode`);
                        const currentChargeName = watch(`chargeDetails.${index}.chargeName`);
                        const sType = (shipmentType || "").toLowerCase();

                        const chargeCodeOptions = (configStore.getChargeCodeList ? configStore.getChargeCodeList(sType) : [])
                            .filter(code => !code || code === currentChargeCode || !otherSelectedCodes.has(code));
                        const chargeNameOptions = (configStore.getChargeDescriptionList ? configStore.getChargeDescriptionList(sType) : [])
                            .filter(name => !name || name === currentChargeName || !otherSelectedNames.has(name));

                        return (
                            <div
                                key={item.id}
                                style={{
                                    display: "flex",
                                    gap: 6,
                                    marginBottom: 12,
                                    padding: 12,
                                }}>
                                {[
                                    { label: "Charge Code", name: "chargeCode" },
                                    { label: "Charge Name", name: "chargeName" },
                                    { label: "Term", name: "term" },
                                    { label: "Currency", name: "currency" },
                                    { label: "ROE", name: "roe",disable:true },
                                    { label: "Unit", name: "unit" },
                                    { label: "No of Unit", name: "noOfUnit" },
                                    { label: "Amount per Unit", name: "amountPerUnit" },
                                    { label: "Amount", name: "amount" },
                                    { label: "Vendor", name: "vendor" },

                                ].map((field) => (
                                    (field.label == 'Charge Name' || field.label == 'Term' || field.label == 'Currency' || 
                                        field.label == 'Vendor' || 
                                        field.label == 'Unit' || field.label == 'Charge Code') ?
                                        <LabeledSelectField labelStyle={selectFieldLabelStyle}
                                        callback={(e)=>{
                                            if (field.label == 'Unit'){
                                                setValue(`chargeDetails.${index}.noOfUnit`,getTotalUnit(e.target.value));
                                            }  
                                            if (field.label == 'Charge Code'){
                                                const chargeNameList = configStore.chargeDescriptionList?.find((f) => f.chargeCode == e.target.value);
                                                setValue(`chargeDetails.${index}.chargeName`, chargeNameList?._id || "");
                                            }
                                            if (field.label == 'Charge Name'){
                                                const chargeName = configStore.chargeDescriptionList?.find((f) => f._id == e.target.value);
                                                setValue(`chargeDetails.${index}.chargeCode`, chargeName?.chargeCode || "");
                                            }
                                            if (field.label == 'Currency'){
                                                setValue(`chargeDetails.${index}.roe`,configStore.getExchangeRate(e.target.value));
                                            }      
                                            if (field.label == 'Vendor') {
                                                setValue(`chargeDetails.${index}.vendorId`, EntityV2Store?.list?.find(f => e.target.value === f.entityName)?.entityId || "");
                                            }               
                                         }}
                                            disabled={masterjobStore.disable || watch(`chargeDetails.${index}.proRate`)} control={control} options={field.label == 'Currency' ? configStore.getCurrencyList() : field.label == 'Unit' ? unitValues : field.label == 'Charge Name' ? chargeNameOptions : field.label == 'Charge Code' ? chargeCodeOptions : field.label == 'Vendor' ? EntityV2Store?.list?.filter(e => e.status !== "DEACTIVATED" && e.status !== "REJECTED")?.map(e => e.entityName) : field.label == 'Term' ? ['Prepaid', 'Collect'] : []} name={`chargeDetails.${index}.${field.name}`} label={field.label} width={'30%'} madatory={field.madatory} /> :
                                        <div
                                            key={field.name}
                                            style={{
                                                flex: "1 1 calc(33.333% - 16px)",
                                                minWidth: 150,
                                            }}
                                        >
                                            <LabeledTextField
                                                labelStyle={textFieldLabelStyle}
                                                disabled={masterjobStore.disable || field.disable || watch(`chargeDetails.${index}.proRate`)}
                                                madatory={field.madatory}
                                                label={field.label}
                                                control={control}
                                                name={`chargeDetails.${index}.${field.name}`}
                                                size="small"
                                                onlyNumberDot={["noOfUnit", "unit", "amountPerUnit", "amount"].includes(field.name)}
                                                onKeyDown={["noOfUnit", "unit", "amountPerUnit", "amount"].includes(field.name) ? handleNumberDotKeyDown : undefined}
                                                onPaste={["noOfUnit", "unit", "amountPerUnit", "amount"].includes(field.name) ? (e) => handleNumberDotPaste(e, field.name, index) : undefined}
                                                callback={(val) => {
                                                    if (["noOfUnit", "unit", "amountPerUnit", "amount"].includes(field.name)) {
                                                        const cleaned = sanitizeNumberDot(val);
                                                        if (cleaned !== val) {
                                                            setValue(`chargeDetails.${index}.${field.name}`, cleaned);
                                                        }
                                                    }
                                                }}
                                            />
                                        </div>
                                ))}
                                {index != 0 ? <div onClick={() => { remove(index) }} className="w-[55px] mt-[30px] h-full flex items-center justify-center cursor-pointer">
                                    <img src={deleteicon} />
                                </div> : <div className="w-[35px] mt-[30px] h-full flex items-center justify-center"></div>}
                            </div>
                        );
                    })}
                    {!masterjobStore.disable ?
                        <div style={{ display: "flex", gap: "10px", justifyContent: 'flex-end', marginRight: '50px' }}><button
                            className="button"
                            onClick={(e) => {
                                e.preventDefault();                                
                                append({
                                    chargeName: '',
                                    chargeCode: '',
                                    term: '',
                                    currency: '',
                                    roe:'',
                                    unit: '',
                                    noOfUnit: '',
                                    amountPerUnit: '',
                                    amount:'',
                                    vendorId: '',
                                    proRate:false
                                })
                            }}
                            style={{
                                padding: "8px 16px",
                                color: '#2B3688',
                                height: "40px",
                                backgroundColor: '#F9FAFB',
                                border: `1px solid #2B3688`,
                                fontSize: '15px',
                                fontFamily: 'figtree'
                            }}
                        >
                            + Add Charges
                        </button>
                        </div> : <></>}
                        <div style={{ display: "flex", gap: "10px", justifyContent: 'flex-end', marginRight: '50px',marginTop:"20px" }}>
                        <p className="text-black text-[#2c358a] font-bold">Total Cost Amount : INR {Math.abs(totalAmount.toFixed(2))}</p>
                        </div>
                </div>
            </div>
            {masterjobStore.edit ?
                <div style={{ display: "flex", gap: "10px", justifyContent: 'flex-end', marginTop: '15px' }}>
                    <ActionButton
                        onClick={(e) => {
                            e.preventDefault()
                            activeTab('Vendor Details')
                        }}
                    >
                        Previous
                    </ActionButton>
                    <button
                        className="button"
                        type="submit"
                        style={{
                            padding: "8px 16px",
                            color: 'white',
                            backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                            height: "40px",
                            border: `1px solid`,
                        }}
                    >
                        Update
                    </button>
                </div> : <></>}
        </>
    )
}


const ActionButton = ({
  children,
  onClick,
  type = "button",
  disabled = false,
  style = {},
}) => {
  return (
    <button
      type={type}
      className="button"
      disabled={disabled}
      onClick={onClick}
      style={{
        padding: "10px 22px",
        height: "40px",
        width: '100px',
        border: `1px solid #4BA7DD`,
        // padding: "8px 16px",
        // height: "40px",
        // border: `1px solid ${process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON}`,
        ...style,
      }}
    >
      {children}
    </button>
  );
};

const Visibility = ({ activeTab }) => {
    const { control, getValues, setValue, watch, register } = useFormContext();
    useSnapshot(configStore);
    useSnapshot(myactionsstore);
    const previousModalData = useRef(configStore.modalvisibledata);
    const [availableKeys, setAvailableKeys] = useState([]);
    const [containerKeys, setContainerKeys] = useState([]);
    const containerDetails = watch("containerDetails") || [];
    let fieldLabels = {}
    let fieldKeys = []

        fieldLabels = dsrstatic_FCLDockDock
        fieldKeys = dsrstatic_FCLDockDock_keys
        fieldLabels = myactionsstore.addts({ ...fieldLabels }, {
            ...(masterjobStore.current.visibilityFields || {}),
            ...(configStore.modalvisibledata || {}),
        })
    if (masterjobStore.current.generalDetails.pod !== masterjobStore.current.generalDetails.fpod) {
            fieldLabels["eta_at_pod"] = "ETA @ POD"
            fieldLabels["pod_arrival"] = "ATA @ POD"
            fieldLabels["etd_pod"] = "ETD from POD"
        }
    if (!["Port-to-Door", "Port-to-Port"].includes(masterjobStore.current.shipmentScope)) {
            fieldKeys = fieldKeys.filter(e => e !== "cargo_gatein_CFS");
        }
    fieldKeys = fieldKeys.filter(e => !["pod_terminal_name", "pod_terminal_operator_code", "terminal_dwell_days", "demurrage_free_time_days","detention_free_days",
        "status_closed", "shipper_name", "branch_name", "consignee_name", 'company',"cust_ref_number","agraga_booking_#","remarks","delivery_order_status","do_remarks",
    ].includes(e))
    useEffect(() => {
        const dsrRecord = masterjobStore.current.visibilityFields || {};
        const hasValue = (value) => {
            if (value === undefined || value === null) return false;
            if (typeof value === "string") return value.trim().length > 0;
            if (Array.isArray(value)) return value.length > 0;
            if (typeof value === "object") return Object.keys(value).length > 0;
            return true;
        };
        const nextAvailableKeys = fieldKeys.filter((fieldKey) => {
            const transshipmentMatch = fieldKey.match(/^ts([1-4])_/);
            if (transshipmentMatch) {
                const transshipmentPort = `ts${transshipmentMatch[1]}_port`;
                if (!hasValue(dsrRecord?.[transshipmentPort])) return false;
            }
            return true;
        });
        const obj = Object.keys(fieldLabels)
        let finalKey
        finalKey = nextAvailableKeys.filter(e=>obj.includes(e))
        setAvailableKeys(finalKey);
        let arr = ["gatein_pol", "gatein_fpod", "container_pickup_fpod", "empty_return"]
        if (masterjobStore.current?.generalDetails?.por != masterjobStore.current?.generalDetails?.pol) {
            arr.push("container_handover")
            arr.push("por_to_pol_movement")
        }
        if (masterjobStore.current?.generalDetails?.pod != masterjobStore.current?.generalDetails?.fpod) {
            arr.push("gateout_to_fpod")
        }
        setContainerKeys(dsrstatic_FCLDockDock_keys.filter(e=> arr.includes(e)))
        setValue("visibilityFields.origin", masterjobStore.current?.generalDetails?.origin || "")
        setValue("visibilityFields.destination", masterjobStore.current?.generalDetails?.destination || "")
        setValue("visibilityFields.por", masterjobStore.current?.generalDetails?.por || "")
        setValue("visibilityFields.pol", masterjobStore.current?.generalDetails?.pol || "")
        setValue("visibilityFields.pod", masterjobStore.current?.generalDetails?.pod || "")
        setValue("visibilityFields.fpod", masterjobStore.current?.generalDetails?.fpod || "")
        setValue("visibilityFields.shipmentType",masterjobStore.current?.service || "")
        setValue("visibilityFields.shipmentScope", masterjobStore.current?.shipmentScope || "")
        configStore.modalvisibledata = {
            ...(masterjobStore.current?.visibilityFields || {}),
            origin: masterjobStore.current?.generalDetails?.origin || "",
            destination: masterjobStore.current?.generalDetails?.destination || "",
            por: masterjobStore.current?.generalDetails?.por || "",
            pol: masterjobStore.current?.generalDetails?.pol || "",
            pod: masterjobStore.current?.generalDetails?.pod || "",
            fpod: masterjobStore.current?.generalDetails?.fpod || "",
            shipmentType: masterjobStore.current?.service || "",
            shipmentScope: masterjobStore.current?.shipmentScope || "",
        }
    }, [setValue]);
    useEffect(() => {
        const data = configStore.modalvisibledata;
        if (previousModalData.current === data) return;
        previousModalData.current = data;
        const transshipmentKeys = dsrstatic_FCLDockDock_keys.filter((key) => /^ts[1-4]_/.test(key));
        const activeTransshipmentKeys = transshipmentKeys.filter((key) => {
            const transshipmentNumber = key.match(/^ts([1-4])_/)[1];
            const port = data?.[`ts${transshipmentNumber}_port`];
            return typeof port === "string" && port.trim().length > 0;
        });
        activeTransshipmentKeys.forEach((key) => {
                setValue(`visibilityFields.${key}`, data?.[key] ?? "");
            });

        const inactiveTransshipmentKeys = transshipmentKeys.filter(
            (key) => !activeTransshipmentKeys.includes(key)
        );

        inactiveTransshipmentKeys.forEach((key) => {
            setValue(`visibilityFields.${key}`, ""); 
        });

            setAvailableKeys((currentKeys) => [
                ...currentKeys.filter((key) => !/^ts[1-4]_/.test(key)),
                ...activeTransshipmentKeys,
            ]);

    }, [configStore.modalvisibledata, setValue]);
    const getDropDownForMLO = ()=>{
        return dataListStore["FCLCarrierList"]
                .filter((carrier) => carrier?.["MLO or NVOCC"] !== "NVOCC")
                .map((carrier) => ({
                    label: carrier["Display Name"],
                    value: `${carrier["Display Name"]} (${carrier["SCAC code"]})`,
        }))
    }
    const getBackendDateValue = (value) => {
        if (!value) return "";
        const match = String(value).match(/^(\d{2})-(\d{2})-(\d{4})$/);
        if (!match) return value;
        return `${match[3]}-${match[2]}-${match[1]}`;
    };
    const getDateInputValue = (value) => {
        if (!value) return ""
        const rawValue = String(value)
        if (/^\d{4}-\d{2}-\d{2}/.test(rawValue)) return rawValue.slice(0, 10)
        const dayFirstDate = rawValue.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/)
        if (dayFirstDate) return `${dayFirstDate[3]}-${dayFirstDate[2]}-${dayFirstDate[1]}`
        const parsedDate = new Date(rawValue)
        if (Number.isNaN(parsedDate.getTime())) return ""
        const year = parsedDate.getFullYear()
        const month = String(parsedDate.getMonth() + 1).padStart(2, "0")
        const day = String(parsedDate.getDate()).padStart(2, "0")
        return `${day}-${month}-${year}`
    }
    const visibilityFields = watch("visibilityFields");
    const fieldsToBeFreezed = (key)=>{
        const fields = ["origin", "destination", "por", "pol", "pod", "fpod", "ts1_port", "ts2_port", "ts3_port","ts4_port"]
        return fields.includes(key)
    }
    return (
        <div className="box">
            <h5 className="title is-5">Visibility Details</h5>
            <div style={{display: 'flex',justifyContent: 'flex-end', gap: '10px', marginBottom: '10px'}}>
                    {
                        masterjobStore.disable ?
                        (<button
                            className="button is-link"
                            onClick={async (e) => {
                                e.preventDefault()
                                myactionsstore.exceptionModalVisible = true;
                                myactionsstore.exceptionModalDisable = true;
                            }}
                        >
                            👁 View Exception
                        </button>) :
                            (<button
                                className="button is-link is-outlined"
                                onClick={async (e) => {
                                    e.preventDefault()
                                    myactionsstore.exceptionModalVisible = true;
                                }}
                            >
                                + Add Exception
                            </button>)
                    }
                    {
                        masterjobStore.disable ?
                        (
                            <button
                                className="button ml-5 is-link"
                                onClick={async (e) => {
                                    e.preventDefault()
                                    myactionsstore.tsModalVisible = true;
                                    myactionsstore.tsModalDisable = true;
                                }}
                            >
                                👁 View Transhipment
                            </button>
                        ):
                        (<button
                        className="button ml-5 is-link is-outlined"
                        onClick={async (e) => {
                            e.preventDefault()
                            configStore.modalvisibledata = { ...(getValues("visibilityFields") || {}) };
                            myactionsstore.tsModalVisible = true;
                        }}
                    >
                        + Add Transhipment
                    </button>)
                    }
            </div>
            <div className="columns is-multiline">
                {availableKeys.map((key) => (
                    <div className="column is-one-third" key={key}>
                        {key === "mlo" ?(
                        <LabeledSelectField labelStyle={selectFieldLabelStyle} disabled={masterjobStore.disable}
                                control={control} placeholder={"Select"} options={getDropDownForMLO()} name={`visibilityFields.${key}`} label={fieldLabels[key] || key} fullwidth={true} />
                        ) : (
                            <>
                                {/* Label */}
                                <p style={{
                                    fontSize: "12px",
                                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                                    fontWeight: "bold",
                                    marginBottom: "4px"
                                }}>
                                    {fieldLabels[key] || key}
                                </p>

                                {visibilityDateTimeFields.has(key) ? (
                                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                        <input
                                            className="input"
                                            type="date"
                                            style={{ width: "60%" }}
                                            value={
                                                visibilityFields?.[key]?.includes("T")
                                                    ? getDateInputValue(visibilityFields[key].split("T")[0])
                                                    : getDateInputValue(visibilityFields?.[key] || "")
                                            }
                                            disabled={masterjobStore.disable || fieldsToBeFreezed(key)}
                                            onChange={(event) => {
                                                const datePart = event.target.value;
                                                const timePart = visibilityFields?.[key]?.includes("T")
                                                    ? visibilityFields[key].split("T")[1]
                                                    : "";

                                                if (!datePart) {
                                                    setValue(`visibilityFields.${key}`, "");
                                                } else {
                                                    setValue(
                                                        `visibilityFields.${key}`,
                                                        timePart ? `${datePart}T${timePart}` : datePart
                                                    );
                                                }
                                            }}
                                        />
                                        <input
                                            className="input"
                                            type="time"
                                            style={{ width: "40%" }}
                                            value={
                                                visibilityFields?.[key]?.includes("T")
                                                    ? visibilityFields[key].split("T")[1]
                                                    : ""
                                            }
                                            disabled={masterjobStore.disable || fieldsToBeFreezed(key)}
                                            onChange={(event) => {
                                                const timePart = event.target.value;
                                                const datePart = visibilityFields?.[key]?.includes("T")
                                                    ? visibilityFields[key].split("T")[0]
                                                    : visibilityFields?.[key] || "";

                                                if (datePart) {
                                                    setValue(
                                                        `visibilityFields.${key}`,
                                                        `${datePart}T${timePart}`
                                                    );
                                                }
                                            }}
                                        />
                                    </div>
                                ) : (
                        <LabeledTextField
                            control={control}
                            name={`visibilityFields.${key}`}
                            value={visibilityDateFields.has(key) ? getBackendDateValue(visibilityFields?.[key]) : visibilityFields?.[key] || ""}
                            label={""}
                            type={visibilityDateFields.has(key) ? "date" : "text"}
                            disabled={masterjobStore.disable || fieldsToBeFreezed(key)}
                            labelStyle={{
                                fontSize: "12px",
                                color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                                fontWeight: "bold",
                            }}
                        />
                                )}
                            </>
                        )}
                    </div>
                ))}
                {containerDetails.map((container, containerIndex) => (
                    <div className="column is-full" key={`container-visibility-${containerIndex}`}>
                        <h6 className="title is-6">
                            Container {`(${container.containerType})`} - {container.containerNumber || container.containerType || containerIndex + 1}
                        </h6>
                        <input
                            type="hidden"
                            {...register(`visibilityFields.containerlist.${containerIndex}.container_types`)}
                            value={container.containerType || ""}
                        />
                        <input
                            type="hidden"
                            {...register(`visibilityFields.containerlist.${containerIndex}.container_number`)}
                            value={container.containerNumber || ""}
                        />
                        <div className="columns is-multiline">
                            {containerKeys.map((key) => (
                                <div className="column is-one-third" key={key}>
                                    <LabeledTextField
                                        control={control}
                                        name={`visibilityFields.containerlist.${containerIndex}.${key}`}
                                        value={visibilityDateFields.has(key) ? getBackendDateValue(visibilityFields.containerlist?.[containerIndex]?.[key]) : visibilityFields.containerlist?.[containerIndex]?.[key] || ""}
                                        label={dsrstatic_cn[key] || key}
                                        type={visibilityDateFields.has(key) ? "date" : "text"}
                                        disabled={masterjobStore.disable}
                                        labelStyle={{
                                            fontSize: "12px",
                                            color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                                            fontWeight: "bold",
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            {masterjobStore.edit ?
                <div style={{ display: "flex", gap: "10px", justifyContent: 'flex-end', marginTop: '15px' }}>
                    <button
                        className="button"
                        type="submit"
                        style={{
                            padding: "8px 16px",
                            color: 'white',
                            backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                            height: "40px",
                            border: `1px solid`,
                        }}
                    >
                        Save
                    </button>
                </div> : <></>}
                <TsModal />
                <ExceptionModal />
        </div>
    )
};


const DocumentCenter = ({ activeTab }) => {
    const [expanded, setExpanded] = useState({});
    const [documentName, setDocumentName] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);

    // const [documentData, setDocumentData] = useState([
    //     {
    //         name: "CIPL",
    //         files: [
    //             { filename: "file1.pdf" },
    //             { filename: "file2.pdf" },
    //         ],
    //     },
    //     {
    //         name: "BL Draft Approval",
    //         files: [
    //             { filename: "file3.pdf" },
    //             { filename: "file4.pdf" },
    //         ],
    //     },
    //     {
    //         name: "Shipping Bill Checklist",
    //         files: [
    //             { filename: "file5.pdf" },
    //             { filename: "file6.pdf" },
    //             { filename: "file7.xlsx" },
    //         ],
    //     },
    // ]);

    const [documentData, setDocumentData] = useState([])

    const toggleAccordion = (index) => {
        setExpanded((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };
    let url = `${process.env.REACT_APP_FILE_SERVER}/api/v1/filestore/storefile`

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];

        if (file) {
            const formData = new FormData()
            formData.append('myFile', file)
            formData.append('label', documentName)
            formData.append('key', masterjobStore.current._id)
            fetch(url, {
                method: 'POST',
                headers: Api.H1(),
                credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
                body: formData
            })
                .then(async response => await response.json())
                .then(data => {
                    if (data.error) {
                        if (data.error !== 'No Error' || data.error !== 'Invalid Token') {
                            configStore.setModalMessage(data.error)
                        }
                    }
                    else {
                        setSelectedFile(data.key.filename);
                    }
                }).catch((error) => {
                    configStore.setModalMessage(error.message)
                })
        }

    };

    const handleUpload = () => {
        if (!documentName.trim() || !selectedFile) {
            configStore.setModalMessage("Please provide a document name and select a file.");
            return;
        }

        const newFile = {
            filename: documentName,
            file: selectedFile,
        };

        masterjobStore.current.files = [
            ...(masterjobStore.current.files || []),
            newFile,
        ];

        setDocumentName("");
        setSelectedFile(null);

        const input = document.getElementById("document-file");

        if (input) {
            input.value = "";
        }
    };

    const handleDelete = (id) => {
        masterjobStore.current.files = masterjobStore.current.files.filter((file) => file.file !== id);
    };

    return (
        <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px] mt-[5px]">

            {documentData?.map((document, index) => {
                const isExpanded = expanded[index] || false;

                return (
                    <div
                        key={index}
                        style={{
                            borderBottom: "1px solid #e5e7eb",
                        }}
                    >

                        {/* HEADER */}

                        <div
                            onClick={() =>
                                toggleAccordion(index)
                            }
                            style={{
                                height: "58px",
                                padding: "0 16px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                cursor: "pointer",
                            }}
                        >

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >

                                {/* CHEVRON */}

                                <div
                                    style={{
                                        width: "32px",
                                        height: "32px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "1px solid #e5e7eb",
                                        borderRadius: "6px",
                                        backgroundColor: "#FFFFFF",
                                    }}
                                >
                                    <img
                                        src={
                                            isExpanded
                                                ? ChevronUp
                                                : ChevronDown
                                        }
                                        alt={
                                            isExpanded
                                                ? "Collapse"
                                                : "Expand"
                                        }
                                        style={{
                                            width: "10px",
                                            height: "5px",
                                            objectFit: "contain",
                                        }}
                                    />
                                </div>

                                {/* DOCUMENT NAME */}

                                <span
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        color: "#272727",
                                    }}
                                >
                                    {document.name}
                                </span>

                            </div>

                            {/* DOCUMENT COUNT */}

                            <span
                                style={{
                                    padding: "2px 8px",
                                    borderRadius: "20px",
                                    backgroundColor: "#f0f2ff",
                                    fontSize: "9px",
                                    fontWeight: 500,
                                    color: "#3446a8",
                                }}
                            >
                                {document.files?.length || 0} docs
                            </span>

                        </div>


                        {isExpanded && (
                            <div
                                style={{
                                    borderTop:
                                        "1px solid #e5e7eb",
                                    padding: "0 20px",
                                }}
                            >

                                {document.files?.map(
                                    (file, fileIndex) => (

                                        <div
                                            key={fileIndex}
                                            style={{
                                                minHeight: "58px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent:
                                                    "space-between",
                                                borderBottom:
                                                    "1px solid #eeeeee",
                                            }}
                                        >

                                            {/* FILE INFO */}

                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                }}
                                            >

                                                {/* FILE ICON */}

                                                <div
                                                    style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#F4F5FF",
                                                        borderRadius: "6px",
                                                    }}
                                                >
                                                    <img
                                                        src={FileText}
                                                        alt="File"
                                                        style={{width: "12px", height: "15px", objectFit: "contain",}} />
                                                </div>

                                                {/* FILE NAME */}

                                                <div>
                                                    <p
                                                        style={{ margin: 0, fontSize: "11px", fontWeight: 600, fontFamily:'figtree', color: "#2B2B2B",}}
                                                    >
                                                        {file.filename ||
                                                            file.filemname}
                                                    </p>

                                                    {file.uploadedBy && (
                                                        <p
                                                            style={{ margin: "2px 0 0", fontSize: "8px", color: "#555", }}
                                                        >
                                                            {
                                                                file.uploadedDate
                                                            }
                                                            {" • "}
                                                            Uploaded by{" "}
                                                            {
                                                                file.uploadedBy
                                                            }
                                                        </p>
                                                    )}
                                                </div>

                                            </div>

                                            {/* ACTIONS */}

                                            <div
                                                style={{
                                                    display: "flex", alignItems: "center", gap: "8px",}}
                                            >

                                                <button
                                                    type="button"
                                                    style={{ width: "30px", height: "30px", display: "flex",  alignItems: "center", justifyContent: "center", border: "1px solid #E5E7EB", borderRadius: "6px", backgroundColor: "#FFFFFF", cursor: "pointer",}}
                                                >
                                                    <img
                                                        src={Eye}
                                                        alt="View"
                                                        style={{ width: "18px", height: "18px", }}
                                                    />
                                                </button>

                                                <button
                                                    type="button"
                                                    style={{ width: "30px", height: "30px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #E5E7EB", borderRadius: "6px", backgroundColor: "#FFFFFF", cursor: "pointer", }}
                                                >
                                                    <img
                                                        src={Download}
                                                        alt="Download"
                                                        style={{width:"18px", height:"18px"}}
                                                    />
                                                </button>

                                            </div>

                                        </div>
                                    )
                                )}

                            </div>
                        )}

                    </div>
                );
            })}

            {masterjobStore.edit  && <div
                style={{
                    padding: "12px 16px",
                }}
            >

                <div
                    style={{
                        marginBottom: "4px",
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#2B2B2B",
                    }}
                >
                    Document Name
                </div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "flex-end",
                        gap: "8px",
                    }}
                >

                    {/* DOCUMENT NAME */}

                    <input
                        type="text"
                        value={documentName}
                        onChange={(e) =>
                            setDocumentName(e.target.value)
                        }
                        placeholder="Enter document name"
                        style={{
                            width: "350px",
                            height: "40px",
                            padding: "0 8px",
                            border: "1px solid #E5E7EB",
                            borderRadius: "6px",
                            outline: "none",
                            fontSize: "14px",
                            boxSizing: "border-box",
                        }}
                    />

                    {/* BROWSE */}

                    <label
                        htmlFor="document-file"
                        style={{
                            width: "250px",
                            height: "50px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                            border: "1px dashed #D1D6FF80",
                            borderRadius: "6px",
                            backgroundColor: "#F4F5FF",
                            color: "#2B3688",
                            fontSize: "13px",
                            fontWeight: 600,
                            cursor: "pointer",
                            boxSizing: "border-box",
                        }}
                    >

                        <img
                            src={UploadCloud}
                            alt="Upload"
                            style={{
                                width: "13px",
                                height: "13px",
                            }}
                        />

                        <span
                            style={{
                                maxWidth: "120px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {selectedFile
                                ? selectedFile
                                : "Browse files"}
                        </span>

                    </label>

                    <input
                        id="document-file"
                        type="file"
                        style={{
                            display: "none",
                        }}
                        onChange={handleFileChange}
                    />

                    {/* UPLOAD */}

                    <button
                        type="button"
                        onClick={handleUpload}
                        style={{
                            height: "35px",
                            padding: "0 16px",
                            border: "none",
                            borderRadius: "6px",
                            backgroundColor: "#303d91",
                            color: "#FFFFFF",
                            fontSize: "13px",
                            fontWeight: 500,
                            cursor: "pointer",
                        }}
                    >
                        Upload
                    </button>

                </div>

            </div>}

            {masterjobStore.current?.files?.length > 0 ? (
                <div
                    style={{
                        padding: "0 20px",
                    }}
                >

                    {masterjobStore.current?.files?.map((file) => (

                        <div
                            key={file.id}
                            style={{
                                minHeight: "48px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent:
                                    "space-between",
                                borderTop:
                                    "1px solid #eeeeee",
                            }}
                        >

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >

                                <div
                                    style={{
                                        width: "32px",
                                        height: "32px",
                                        display: "flex",
                                        alignItems:
                                            "center",
                                        justifyContent:
                                            "center",
                                        backgroundColor:
                                            "#f0f2ff",
                                        borderRadius: "6px",
                                    }}
                                >
                                    <img
                                        src={FileText}
                                        alt="File"
                                        style={{
                                            width: "12px",
                                            height: "15px",
                                        }}
                                    />
                                </div>

                                <span
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        color: "#2B2B2B",
                                    }}
                                >
                                    <DocumentViewerWrapper>
                                        <DocumentRenderer render={(updateDocumentState) => {
                                            return <a onClick={() => {
                                                updateDocumentState({ documentViewUrl: process.env.REACT_APP_FILE_SERVER + '/api/v1/filestore/getfile/' + masterjobStore.current._id + '/' + file.file, documentTitle: file.filename, open: true })
                                            }} >
                                                {file.filename}
                                            </a>
                                        }} />
                                    </DocumentViewerWrapper>
                                </span>

                            </div>

                            {masterjobStore.edit && (
                                <button
                                    type="button"
                                    onClick={() =>
                                        handleDelete(file.file)
                                    }
                                    style={{
                                    width: "28px",
                                    height: "28px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1px solid #E5E7EB",
                                    borderRadius: "6px",
                                    backgroundColor: "#FFFFFF",
                                    cursor: "pointer",
                                }}
                            >
                                <img
                                    src={Trash2}
                                    alt="Delete"
                                    style={{
                                        width: "12px",
                                        height: "12px",
                                    }}
                                />
                            </button>)}

                        </div>

                    ))}

                </div>
            ) : <div style={{display:"flex",justifyContent: 'center'}}>No documents found</div>}
            {(!masterjobStore.disable) ?
                <div style={{ display: "flex", gap: "10px", justifyContent: 'flex-end', marginTop: '15px' }}>
                    {/* <ActionButton
                        onClick={(e) => {
                            e.preventDefault()
                            activeTab('Charge Details')
                        }}
                    >
                        Previous
                    </ActionButton> */}
                    {(masterjobStore.edit) && 
                        <button
                            className="button"
                            type="submit"
                            style={{
                                padding: "8px 16px",
                                color: 'white',
                                backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                                height: "40px",
                                border: `1px solid`,
                            }}
                        >
                            Save
                        </button>}
                </div> : <></>}
        </div>
    );
};


export function Popup({onClose,onSubmit,successBtn,content }) {
    const styles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.35)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000
        },

        modal: {
            width: "520px",
            background: "#fff",
            borderRadius: "12px",
            padding: "40px 30px",
            textAlign: "center",
            position: "relative",
            boxShadow: "0 4px 25px rgba(0,0,0,0.2)"
        },

        close: {
            position: "absolute",
            top: "15px",
            right: "18px",
            fontSize: "20px",
            cursor: "pointer",
            border: "none",
            background: "none"
        },

        message: {
            fontSize: "18px",
            color: "#333",
            lineHeight: "28px",
            marginBottom: "35px",
            fontFamily: 'figtree'
        },

        button: {
            background: "#3a4694",
            color: "#fff",
            border: "none",
            padding: "10px 30px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "16px",
            fontFamily: 'figtree'
        }
    };

    return (
        <div style={styles.overlay} onClick={() => onClose(false)}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div style={styles.message}>{content}</div>
                    <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                        <button style={{ border: "1px solid black/400 #878787", background: "transparent", padding: "10px 30px", borderRadius: "6px", cursor: "pointer", fontSize: "16px", fontFamily: 'figtree' }}
                            onClick={(e) =>{
                                e.preventDefault();
                                onClose(false)
                            }
                        }>
                            Cancel
                        </button>
                        <button style={{ background: "#2B3688", color: "#E6F0FF", border: "none", padding: "10px 30px", borderRadius: "6px", cursor: "pointer", fontSize: "16px", fontFamily: 'figtree' }}
                            onClick={(e) => {
                                e.preventDefault();
                                onSubmit()
                            }}>
                        {successBtn}
                        </button>
                    </div>
            </div>
        </div>
    );
}





